<template>
  <v-app>
    <LoadingDialog :isLoading="isLoading" />

    <!-- นโยบายเซสชัน §6 — อยู่ระดับแอปเพื่อให้ dialog ล็อกอิน **ซ้อนทับ** จอที่เปิดอยู่
         ไม่ใช่เปลี่ยน state ไปหน้าล็อกอิน (ซึ่งจะทำให้ฟอร์มที่กรอกค้างไว้หายทั้งหมด) -->
    <SessionGuard v-if="!isAuthScreen" ref="sessionGuard" @onLoggedOut="logout" @onRelogin="afterRelogin" />

    <!-- ===== AUTH SCREENS (full-screen, no shell) =====
         (the login screen renders its own seasonal decorations inside its hero) -->
    <!-- floating language picker — the auth screens sit above the shell topbar, so
         they need their own switch (covers Login / ForgotPassword / Register) -->
    <lang-picker v-if="isAuthScreen" float />
    <Transition v-if="isAuthScreen" name="fade" mode="out-in">
      <Login v-if="state == 'login'" :ui-theme="effectiveTheme" @onAffterLogin="AffterLogin($event)"
        @onErrorHandler="onError($event)" @onInfoHandler="onShowInfoDialog($event)"
        @onResigterHandler="onClickChangeState($event)" @onLoading="onLoading($event)"></Login>

      <ForgotPassword v-else-if="state == 'forgotpassword'" @onErrorHandler="onError($event)"
        @onSuccessHandler="onSuccess($event)" @onForgotHandler="onClickChangeState($event)"
        @onLoading="onLoading($event)"></ForgotPassword>

      <Register v-else-if="state == 'register'" @onBacktoLogin="backToLogin" @onErrorHandler="onError($event)"
        @onSuccessHandler="onSuccess($event)" @onCancelHandler="onClickChangeState($event)"
        @onLoading="onLoading($event)"></Register>
    </Transition>

    <!-- ===== iStar APP SHELL (logged-in) ===== -->
    <!-- embed = หน้าต่างแยก (?embed=1): ไม่มีไซด์เมนู/แท็บล่าง/แถบบน — ไม่ใช่ "รูปแบบที่ 3" ของ
         MENU_SCROPE แต่เป็นหน้าต่างที่ไม่มีเมนูเลย (อวตาร์ = 0 ได้ที่นี่ที่เดียว) -->
    <div v-else class="shell" :class="{ 'bottom-tabs': useBottomTabs && !embed, collapsed: collapsed, embed: embed }">
      <div class="scrim" :class="{ show: drawer }" @click="drawer = false"></div>

      <!-- แท็บล่าง = "รูปแบบที่ 1" ของสเปก: จอมือถือ + เมนูที่คนนั้นมีสิทธิ์ ≤4 รายการ
           ไม่ผูกกับ role แล้ว — โค้ชที่มีเมนูน้อยก็ได้แท็บล่างเหมือนลูกค้า และถ้าวันหน้าใครถูก
           เพิ่มสิทธิ์จนเกิน 4 ระบบสลับไปเป็นไซด์เมนู (รูปแบบที่ 2) ให้เองอัตโนมัติ -->
      <nav class="bottombar" v-if="useBottomTabs && !embed">
        <a v-for="it in bottomTabs" :key="it.value" class="tab" :class="{ on: state === it.value }"
          :href="pageHref(it.value)" draggable="false" @click="onNavClick($event, it)">
          <span class="mdi" :class="it.icon"></span><span>{{ it.label }}</span>
        </a>
      </nav>

      <!-- sidebar — hover hint ของโหมด mini-rail ใช้ delegation ที่นี่ (scroll แล้วตำแหน่งเก่าเพี้ยน → ซ่อน) -->
      <aside v-if="!embed" class="side" :class="{ open: drawer }" @mouseover="onSideNavHover"
        @mouseleave="hideNavTip">
        <!-- twinkling stars — sit behind the nav (.side > *:not(.side-spark) raises the rest) -->
        <span v-for="(s, i) in sparks" :key="'s' + i" class="side-spark"
          :style="{ left: s.x + '%', top: s.y + '%', '--o': (s.o * 0.8), fontSize: (s.sz * 0.8) + 'px', animationDelay: s.d + 's', animationDuration: s.dur + 's' }">
          <span class="mdi mdi-star-four-points"></span>
        </span>
        <!-- โปรไฟล์แทนบล็อกแบรนด์ "iStar Gymnastics" บนสุดของไซด์เมนู
             กฎเดียวทั้งระบบ: "มีไซด์เมนูเมื่อไหร่ โปรไฟล์อยู่ในไซด์เมนู" — ไม่ผูกกับ role
             อวตาร์บนแถบบนจึงมีได้เฉพาะรูปแบบที่ 1 (แท็บล่าง) ซึ่งไม่มีไซด์เมนูให้ใส่
             ก่อนหน้านี้ผูกไว้กับ role ทำให้ลูกค้าบนเดสก์ท็อป (ซึ่งมีไซด์เมนู) เห็นอวตาร์ซ้ำ 2 จุด
             กดแล้วไปหน้าแก้ไขข้อมูลผู้ใช้งาน ซึ่งเป็นทางเดียวที่เข้าหน้านั้นได้หลังกลุ่มเมนู "บัญชี"
             ถูกยุบออกจากไซด์บาร์ (บนมือถือกดแล้วเปิดแผ่นเลื่อนขึ้นแทน — ดู onProfileTap)
             ใช้ .side-brand ร่วมด้วยเพื่อรับกฎ "ย่อเมนูแล้วซ่อนข้อความ + จัดไอคอนกึ่งกลาง" ของเดิม
             และ .nav-item เพื่อรับ hover/active/ป้ายชื่อลอยตอนย่อเมนู (data-label) -->
        <div class="side-brand side-profile nav-item"
          :class="{ on: state === 'editprofile' }"
          :data-label="parent" @click="onProfileTap">
          <!-- ยังไม่ได้ตั้งรูปโปรไฟล์ = ใช้โลโก้ iStar แทนอักษรย่อชื่อ (เจ้าของสั่ง) -->
          <span class="side-profile-av">
            <img :src="userProfileImage || istarLogo" alt=""
              :class="{ 'av-logo': !userProfileImage }" />
          </span>
          <div>
            <div class="side-profile-name">{{ parent }}</div>
            <div class="side-role"><span class="side-role-tag" v-if="userRoleLabel">{{ userRoleLabel }}</span></div>
          </div>
        </div>

        <!-- เฉพาะ "รายการเมนู" ที่เลื่อนได้ — ของเดิมให้ทั้ง .side เลื่อน ปุ่มย่อเมนูกับออกจากระบบ
             จึงไหลไปอยู่ท้ายเนื้อหา พอผู้จัดการมีเมนูยาวเกินจอ (เนื้อหา ~1,324px บนจอสูง 800px)
             ปุ่มย่อเมนูตกไปอยู่ที่ y≈1217 = มองไม่เห็นจนกว่าจะเลื่อนไซด์บาร์ลงสุด
             (scroll event ไม่ bubble จึงต้องย้าย @scroll มาไว้ที่ตัวที่เลื่อนจริงด้วย) -->
        <div class="side-nav" @scroll.passive="hideNavTip">
        <!-- items ปกติสลับ state; item ที่มี external=true (เอกสารรับจ่าย) เปิดระบบภายนอกผ่าน SSO -->
        <!-- เป็น <a href="?page=…"> จริง ไม่ใช่ div — คลิกขวา "เปิดในแท็บใหม่" / Ctrl-คลิก / คลิกกลาง
             จึงใช้ได้ตามปกติของเบราว์เซอร์ ส่วนคลิกซ้ายธรรมดา onNavClick ดักไว้ให้สลับหน้าในแอปเหมือนเดิม
             เมนูภายนอกไม่มี href โดยตั้งใจ: มันส่งโทเคนผ่าน #t ตอนกด ห้ามโผล่ในลิงก์ที่คัดลอกได้ -->
        <!-- หัวกลุ่มคลิกได้เพื่อหุบ/กาง (per-group collapse) — คีย์ด้วย grp.key (= labelKey) -->
        <template v-for="grp in navGroups" :key="grp.key">
          <div class="nav-sec" role="button" tabindex="0"
            :class="{ collapsed: isGroupCollapsed(grp.key) }"
            :aria-expanded="String(!isGroupCollapsed(grp.key))"
            @click="toggleGroup(grp.key)"
            @keydown.enter.prevent="toggleGroup(grp.key)"
            @keydown.space.prevent="toggleGroup(grp.key)">
            <span class="nav-sec-label">{{ grp.label }}</span>
            <span class="mdi nav-sec-chev" :class="isGroupCollapsed(grp.key) ? 'mdi-chevron-right' : 'mdi-chevron-down'"></span>
          </div>
          <div class="nav-group-items" :class="{ collapsed: isGroupCollapsed(grp.key) }">
            <div class="nav-group-inner">
              <a v-for="it in grp.items" :key="it.value" class="nav-item" :class="{ on: state === it.value }"
                :href="it.external ? undefined : pageHref(it.value)" draggable="false"
                :tabindex="navItemHidden(grp.key) ? -1 : undefined"
                :data-label="it.label" @click="onNavClick($event, it)">
                <span class="mdi" :class="it.icon"></span><span class="nav-label">{{ it.label }}</span>
                <!-- ↗ เปิดในหน้าต่างแยก — โผล่ตอนชี้ (จอกว้างเท่านั้น · โหมดย่อเมนูซ่อน ไม่มีที่วาง)
                     เป็น span ไม่ใช่ button เพราะปุ่มซ้อนใน <a> ผิด HTML · aria-hidden: ไม่งั้นชื่อลิงก์
                     ที่โปรแกรมอ่านจอได้ยินกลายเป็น "แดชบอร์ด เปิดในหน้าต่างแยก" · คีย์บอร์ด/โปรแกรมอ่านจอ
                     ใช้ปุ่มเดียวกันบนแถบบนแทน · .stop.prevent = ไม่ให้ลิงก์แม่ทำงานต่อ -->
                <span v-if="!it.external && canPopOut" class="nav-pop mdi mdi-open-in-new" aria-hidden="true"
                  v-hint="$t('nav.popOut')" @click.stop.prevent="popOut(it.value)"></span>
              </a>
            </div>
          </div>
        </template>
        </div>

        <!-- ท้ายเมนู ปักไว้นอกพื้นที่เลื่อน จึงเห็นเสมอไม่ว่าเมนูจะยาวแค่ไหน -->
        <div class="side-foot">
          <div class="nav-item collapse-toggle" :data-label="collapsed ? $t('nav.expandMenu') : $t('nav.collapseMenu')"
            @click="collapsed = !collapsed; hideNavTip()">
            <span class="mdi" :class="collapsed ? 'mdi-chevron-right' : 'mdi-chevron-left'"></span>
            <span class="nav-label">{{ collapsed ? $t('nav.expandMenu') : $t('nav.collapseMenu') }}</span>
          </div>
          <div class="side-divider"></div>
          <div class="nav-item nav-logout" :data-label="$t('nav.logout')" @click="onClickLogout()">
            <span class="mdi mdi-logout"></span><span class="nav-label">{{ $t('nav.logout') }}</span>
          </div>
        </div>
      </aside>

      <!-- collapsed-rail hover hint — fixed-position float ตัวเดียว (แถบเมนูย่อเป็น scroll
           container แล้ว pseudo-element ข้างในจะโดนคลิป จึงลอยไว้ระดับ shell แทน) -->
      <div v-if="navTip.show" class="nav-tip"
        :style="{ left: navTip.x + 'px', top: navTip.y + 'px' }">{{ navTip.text }}</div>

      <!-- เมนูบัญชี — ตัวเดียวใช้ร่วมทั้ง 2 รูปแบบ (เปิดจากอวตาร์แถบบน หรือแถวโปรไฟล์ในไซด์เมนู)
           teleport ออกไป <body> เพราะ .topbar มี backdrop-filter ซึ่งสร้าง containing block ใหม่
           ให้ลูกที่เป็น position:fixed — ถ้าอยู่ใน .topbar แผ่นจะยึดกรอบแถบบนแทน viewport
           แล้วลอยค้างแถวบนจอ ไม่ชิดขอบล่างจริง · ≤900px = แผ่นเลื่อนขึ้น, >900px = กล่องเล็กปกติ -->
      <Teleport to="body">
        <template v-if="userMenu">
          <div class="theme-scrim tb-account-scrim" @click="userMenu = false"></div>
          <div class="popmenu theme-menu tb-account-sheet">
            <div class="popmenu-head"><span class="popmenu-name">{{ parent }}</span></div>
            <button class="popmenu-item" @click="userMenu = false; onClickChangeState('editprofile')">
              <span class="mdi mdi-account-edit"></span> {{ $t('nav.editProfile') }}
            </button>
            <div class="popmenu-divider"></div>
            <button class="popmenu-item" @click="userMenu = false; onClickLogout()">
              <span class="mdi mdi-logout"></span> {{ $t('nav.logout') }}
            </button>
            <!-- ปุ่มยกเลิกเฉพาะโหมดแผ่นเลื่อนขึ้น — บนมือถือแตะนอกแผ่นให้โดนยาก ต้องมีทางปิดที่ชัด -->
            <button class="popmenu-item tb-sheet-cancel" @click="userMenu = false">
              <span class="mdi mdi-close"></span> {{ $t('btn.cancel') }}
            </button>
          </div>
        </template>
      </Teleport>

      <!-- main column -->
      <div class="main">
        <!-- seasonal backdrops — sit behind the page content (z-index:-1), paint only ·
             ผูกกับ effectiveTheme ไม่ใช่ uiTheme: เครื่องที่เปิดโหมดมืดจะได้ 'dark' ซึ่งไม่ตรง
             กับ id ไหนเลย overlay จึงหายไปพร้อมกับพาเลตต์ฤดูกาลเป็นชุดเดียวกัน -->
        <MothersDayOverlay v-if="effectiveTheme === 'mothersday'" />
        <LoyKrathongOverlay v-if="effectiveTheme === 'loykrathong'" />
        <NewYearOverlay v-if="effectiveTheme === 'newyear'" />
        <SongkranOverlay v-if="effectiveTheme === 'songkran'" />
        <HalloweenOverlay v-if="effectiveTheme === 'halloween'" />
        <ChristmasOverlay v-if="effectiveTheme === 'christmas'" />
        <FathersDayOverlay v-if="effectiveTheme === 'fathersday'" />
        <MuayThaiOverlay v-if="effectiveTheme === 'muaythai'" />

        <!-- หน้าต่างแยก (embed) ไม่มีแถบบน ยกเว้นตอนอยู่ในขั้นย่อยที่มีปุ่มย้อนกลับ (เช่น หน้าแรก →
             หน้าจอง) ไม่งั้นหน้าต่างแบบ popup ที่ไม่มีปุ่ม Back ของเบราว์เซอร์จะกลับไม่ได้ ·
             ไม่ mount กระดิ่งในหน้าต่างแยก = ไม่โพลแจ้งเตือนซ้ำทุกบาน -->
        <div class="topbar" v-if="!embed || black">
          <!-- รูปแบบที่ 1 (แท็บล่าง) เท่านั้น: ไม่มีไซด์เมนูให้วางโปรไฟล์ อวตาร์จึงมาอยู่ซ้ายสุด
               ของแถบบน เป็นทางเดียวที่เข้าแก้ไขข้อมูล/ออกจากระบบได้ · รูปแบบที่ 2 ใช้แถวโปรไฟล์
               บนสุดของไซด์เมนูแทน จึงไม่มีอวตาร์ตรงนี้ (ไม่งั้นซ้ำ 2 จุด) -->
          <div class="theme-wrap tb-account-left" v-if="useBottomTabs && !embed">
            <span class="tt-avatar tb-avatar" style="background:var(--c-primary);cursor:pointer;overflow:hidden"
              @click="userMenu = !userMenu">
              <img :src="userProfileImage || istarLogo" alt=""
                :class="{ 'av-logo': !userProfileImage }" />
            </span>
          </div>

          <!-- แฮมเบอร์เกอร์ = เฉพาะจอมือถือ (เปิด/ปิดลิ้นชัก) เจ้าของสั่งว่าเดสก์ท็อปห้ามซ่อน
               ไซด์เมนู ทำได้แค่ย่อ/ขยายจากปุ่มท้ายเมนู ปุ่มนี้จึงไม่มีบนจอกว้าง -->
          <button v-if="!useBottomTabs && isNarrow && !embed" class="id-btn id-btn-ghost id-btn-sm burger"
            @click="drawer = !drawer">
            <span class="mdi mdi-menu"></span>
          </button>
          <button v-if="black" class="id-btn id-btn-ghost id-btn-sm" @click="onClickBack(recentState)">
            <span class="mdi mdi-arrow-left"></span>
          </button>
          <!-- ไม่มีชื่อหน้าบนแถบบนแล้ว — ทุกหน้ามีหัวข้อของตัวเองใน .pg-head อยู่แล้ว ซ้ำซ้อน -->
          <div class="sp"></div>

          <!-- ↗ เปิดหน้านี้ในหน้าต่างแยก — จอกว้างเท่านั้น (มือถือ/PWA เปิด popup ไม่ได้จริง ได้แค่แท็บ) -->
          <button v-if="!embed && canPopOut && currentPage" class="lang-btn tb-popout"
            v-hint="$t('nav.popOut')" :aria-label="$t('nav.popOut')" @click="popOut(currentPage)">
            <span class="mdi mdi-open-in-new"></span>
          </button>

          <!-- theme picker — system-wide setting, head/admin only -->
          <div class="theme-wrap" v-if="canEditTheme && !embed" v-click-outside="() => { themeMenu = false }">
            <button class="lang-btn theme-btn" v-hint="$t('dialog.selectTheme')"
              @click="themeMenu = !themeMenu">
              <span class="mdi mdi-palette"></span>
              <span class="theme-btn-label">{{ activeThemeName }}</span>
            </button>
            <template v-if="themeMenu">
              <div class="theme-scrim" @click="themeMenu = false"></div>
              <div class="popmenu theme-menu">
                <div class="popmenu-head">
                  <span class="popmenu-name">{{ $t('dialog.selectTheme') }}</span>
                </div>
                <button v-for="opt in themeOptions" :key="opt.id" class="popmenu-item theme-opt"
                  :class="{ on: uiTheme === opt.id }" @click="selectTheme(opt.id)">
                  <span class="theme-sw" :style="{ background: opt.swatch }"></span>
                  <span class="theme-opt-tx">
                    <span class="theme-opt-name">{{ opt.name }}</span>
                    <span class="theme-opt-sub">{{ opt.sub }}</span>
                  </span>
                  <span v-if="uiTheme === opt.id" class="mdi mdi-check theme-opt-check"></span>
                </button>
                <div class="theme-note">
                  <span class="mdi mdi-information-outline"></span>
                  <span>{{ $t('dialog.themeNote') }}</span>
                </div>
                <!-- เครื่องของหัวหน้าเองเปิดโหมดมืดอยู่ = ธีมที่เพิ่งกดเลือกจะไม่เปลี่ยนอะไรบนจอนี้
                     เลย ถ้าไม่บอกไว้ตรงนี้จะดูเหมือนปุ่มเสีย ทั้งที่คนอื่นที่ใช้โหมดสว่างเห็นธีมปกติ -->
                <div class="theme-note" v-if="prefersDark">
                  <span class="mdi mdi-weather-night"></span>
                  <span>{{ $t('dialog.themeDarkNote') }}</span>
                </div>
              </div>
            </template>
          </div>

          <lang-picker v-if="!embed" />

          <!-- กระดิ่งแจ้งเตือน — ขวาสุดของแถบบน · **ทุกคนที่ล็อกอิน รวมผู้ปกครองแล้ว**
               ไม่ผูกสิทธิ์เมนู: กล่องแจ้งเตือนเป็นของ "คน" ไม่ใช่ของเมนู โค้ชที่ไม่มีเมนู
               แอดมินเลยก็ยังต้องรู้ว่าถูกจัดคาบ Private
               เดิมตัดฝั่งลูกค้าออก (v-if="!customerflag") เพราะยังไม่มีการแจ้งเตือนอะไรถึง
               ผู้ปกครองเลย กระดิ่งที่ว่างตลอดเวลาไม่ให้ข้อมูลอะไร — เหตุผลนั้นหมดไปแล้วเมื่อ
               การ์ด "คอร์สใกล้หมด/หมดอายุ" ย้ายมาอยู่ในกระดิ่ง (2026-08-05) -->
          <notification-bell v-if="!embed" @go="openFromNotification($event)" />
        </div>

        <div class="page">
            <!-- เปิดจากลิงก์ ?page= แล้วกำลังรอ /getMyMenus ตัดสินสิทธิ์ (state '') — วงหมุนเล็ก ๆ ที่
                 โผล่หลัง 0.4 วิ ปกติตอบไวกว่านั้นจึงไม่เห็นเลย แต่เน็ตช้า (timeout 15 วิ) ต้องไม่ใช่จอเปล่า
                 ไม่ใช้ม่านโหลดกลางเพราะ watch(state) ล้างมันทุกครั้งที่เปลี่ยนหน้า -->
            <div v-if="state === ''" class="page-wait" aria-busy="true">
              <span class="mdi mdi-loading mdi-spin"></span>
            </div>
            <!-- no page transition: out-in deadlocks into a permanent blank if a child errors during enter -->
            <Home v-if="state == 'home'" @collectData="collectData($event)" @initBack="initBlackButton($event)"
              @onInvalidToken="invalidToken($event)" @onClickChangeState="onClickChangeState($event)"
              @onErrorHandler="onError($event)" @onInfoHandler="onShowInfoDialog($event)" :student="student"
              @onLoading="onLoading($event)"></Home>

            <ViewClasses v-else-if="state == 'viewclasses'" @collectData="collectData($event)"
              @initBack="initBlackButton($event)" @onInvalidToken="invalidToken($event)"
              @onClickChangeState="onClickChangeState($event)" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onLoading="onLoading($event)">
            </ViewClasses>

            <Reservation v-else-if="state == 'reservation'" @initBack="initBlackButton($event)"
              @onInvalidToken="invalidToken($event)" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onSuccessHandler="onClickBack($event)" :student="student"
              @onLoading="onLoading($event)"></Reservation>

            <GroupReservation v-else-if="state == 'groupreservation'" @initBack="initBlackButton($event)"
              @onInvalidToken="invalidToken($event)" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onSuccessHandler="onClickBack($event)"
              @onLoading="onLoading($event)"></GroupReservation>

            <FamilyList v-else-if="state == 'familylist'" @initBack="initBlackButton($event)"
              @onClickChangeState="onClickChangeState($event)" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onLoading="onLoading($event)"></FamilyList>

            <AddFamily v-else-if="state == 'addfamilymember'" @initBack="initBlackButton($event)"
              @onClickChangeState="onClickChangeState($event)" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onLoading="onLoading($event)"></AddFamily>

            <!-- การ์ดสถิติของ Dashboard ระบายสีตามจำนวนการจอง (heat map) ด้วย inline style จึงทับ
                 CSS token ของธีมเสมอ — ต้องบอกโหมดผ่าน prop ให้มันเลือกชุดสีเองและ re-render
                 เมื่อผู้ใช้สลับโหมดที่เครื่องกลางคัน -->
            <Dashboard v-else-if="state == 'dashboard'" :dark-mode="prefersDark" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)" @onLoading="onLoading($event)"></Dashboard>

            <InsightView v-else-if="state == 'insightview'" :manager-flag="managerflag" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onSuccessHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)" @onLoading="onLoading($event)"></InsightView>

            <OpsChecklist v-else-if="state == 'opschecklist'" @onErrorHandler="onError($event)"
              @onClickChangeState="onClickChangeState($event)"></OpsChecklist>

            <ChatbotView v-else-if="state == 'chatbot'" @onErrorHandler="onError($event)"
              @onClickChangeState="onClickChangeState($event)"></ChatbotView>

            <AccountingSync v-else-if="state == 'accountingsync'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)" @onLoading="onLoading($event)"></AccountingSync>
            <FinanceReport v-else-if="state == 'financereport'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)" @onLoading="onLoading($event)"></FinanceReport>

            <BookingManagement v-else-if="state == 'bookingmanager'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></BookingManagement>

            <PrivateBookingManagement v-else-if="state == 'privatebookingmanager'" :initial-date="notifyDate"
              :key="'pbm' + (notifyDate || '')" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></PrivateBookingManagement>

            <EventManager v-else-if="state == 'eventmanager'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></EventManager>

            <GroupingSheet v-else-if="state == 'groupingmanager'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></GroupingSheet>

            <!-- :key ผูกกับ notifyDate เพื่อ "รีเซ็ตหน้าใหม่" เมื่อกดการ์ดแจ้งเตือนของอีกวัน
                 ขณะที่ยืนอยู่บนหน้านี้อยู่แล้ว — ถ้าไม่ทำ component จะไม่ถูกสร้างใหม่และ
                 initial-date จะไม่มีผล (ผู้ใช้กดแล้วเหมือนไม่มีอะไรเกิดขึ้น) -->
            <GroupingSheet v-else-if="state == 'coachschedule'" coach-mode :initial-date="notifyDate"
              :key="'cs' + (notifyDate || '')" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></GroupingSheet>

            <CoachLeave v-else-if="state == 'coachleave'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></CoachLeave>

            <CoachLeave v-else-if="state == 'leaveapproval'" approval-mode :quota-editable="managerflag"
              @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></CoachLeave>

            <GymnastManagement v-else-if="state == 'gymnastmanager'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></GymnastManagement>

            <CustomerCourse v-else-if="state == 'customercourse'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></CustomerCourse>

            <CustomerCourseFinished v-else-if="state == 'customercoursefinished'" @onErrorHandler="onError($event)"
              @onSuccessHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></CustomerCourseFinished>

            <ScheduleAdmin v-else-if="state == 'course' || state == 'classes'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></ScheduleAdmin>

            <ClosureManagement v-else-if="state == 'holidaymanager'" @onErrorHandler="onError($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onLoading="onLoading($event)"></ClosureManagement>

            <AccountManagement v-else-if="state == 'accountmanager'" :manager-flag="managerflag"
              @onErrorHandler="onError($event)" @onInfoHandler="onShowInfoDialog($event)"
              @onSuccessHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onLoading="onLoading($event)"></AccountManagement>

            <MenuPermissionManagement v-else-if="state == 'menupermissionmanager'"
              @onErrorHandler="onError($event)" @onInfoHandler="onShowInfoDialog($event)"
              @onClickChangeState="onClickChangeState($event)" @onMenuPermissionSaved="fetchMyMenus()"
              @onLoading="onLoading($event)"></MenuPermissionManagement>

            <EditProfile v-else-if="state == 'editprofile'" :user-role="userRoleLabel"
              @onErrorHandler="onError($event)" @onSuccessHandler="onShowInfoDialog($event)"
              @onInfoHandler="onShowInfoDialog($event)" @onClickChangeState="onClickChangeState($event)"
              @onProfileImageUpdated="onProfileImageUpdated($event)"
              @onLoading="onLoading($event)"></EditProfile>
        </div>
      </div>

      <!-- AI Chatbot — FAB ลอย (panel teleport to body ในตัว component) แสดงเฉพาะคนที่มีสิทธิ์เมนู chatbot
           ผูกกับ myMenus ไม่ผูก role ตรง ๆ (กฎเหล็ก MENU_SCROPE §2) -->
      <ChatbotFab v-if="showChatbotFab" @onErrorHandler="onError($event)" />
    </div>

    <!-- ===== centralized dialogs ===== -->
    <!-- id-modal (token-driven) so every theme paints it — the old v-dialog went white in Halloween -->
    <id-modal v-model="ConfirmLogoutDialog" size="sm" persistent icon="mdi-logout" :title="$t('nav.logout')">
      {{ $t('auth.logoutConfirm') }}
      <template #footer>
        <button class="id-btn id-btn-ghost" @click="ConfirmLogoutDialog = false">{{ $t('common.no') }}</button>
        <button class="id-btn id-btn-primary" @click="logout()">{{ $t('common.yes') }}</button>
      </template>
    </id-modal>

    <v-dialog width="500" v-model="errorDialog" :z-index="2700" scrim="rgba(0,0,0,0.5)">
      <template v-slot:default>
        <v-card>
          <div class="app-dialog-header app-dialog-header--error">
            <v-icon size="22" color="#dc2626">mdi-alert-circle</v-icon>
            <span>{{ $t('dialog.error') }}</span>
          </div>
          <v-card-text class="app-dialog-body">
            {{ errorMsg }}
          </v-card-text>
          <v-card-actions>
            <v-btn color="#dc2626" variant="tonal" block @click="errorDialog = false">{{ $t('common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog width="500" v-model="successDialog" :z-index="2700" scrim="rgba(0,0,0,0.5)">
      <template v-slot:default>
        <v-card>
          <div class="app-dialog-header app-dialog-header--success">
            <v-icon size="22" color="#16a34a">mdi-check-circle</v-icon>
            <span>{{ $t('dialog.success') }}</span>
          </div>
          <v-card-text class="app-dialog-body">
            {{ infoMsg }}
          </v-card-text>
          <v-card-actions>
            <v-btn color="#16a34a" variant="tonal" block @click="successDialog = false">{{ $t('common.ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from 'axios'
import Login from './components/Login.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import Register from './components/Register.vue'
import Home from './components/Home.vue'
import ViewClasses from '@/components/ViewClasses.vue'
import Reservation from '@/components/Reservation.vue'
import GroupReservation from '@/components/GroupReservation.vue'
import FamilyList from './components/FamilyList.vue'
import AddFamily from './components/AddFamily.vue';
import Dashboard from './components/admin/Dashboard.vue'
import InsightView from '@/components/admin/InsightView.vue';
import OpsChecklist from '@/components/admin/OpsChecklist.vue';
import ChatbotView from '@/components/admin/ChatbotView.vue';
import ChatbotFab from '@/components/admin/ChatbotFab.vue';
import FinanceReport from '@/components/admin/FinanceReport.vue';
import AccountingSync from '@/components/admin/AccountingSync.vue';
import GymnastManagement from '@/components/admin/GymnastManagement.vue';
import BookingManagement from '@/components/admin/BookingManagement.vue';
import PrivateBookingManagement from '@/components/admin/PrivateBookingManagement.vue';
import EventManager from '@/components/admin/EventManager.vue';
import CustomerCourse from '@/components/admin/CustomerCourse.vue';
import CustomerCourseFinished from './components/admin/CustomerCourseFinished.vue'
// จัดการคอร์ส + จัดการคลาส เดิม ถูกยุบรวมเป็นหน้า "จัดการตารางเรียน" (ScheduleAdmin) หน้าเดียว
import ScheduleAdmin from './components/admin/ScheduleAdmin.vue'
import ClosureManagement from './components/admin/ClosureManagement.vue'
import GroupingSheet from '@/components/admin/GroupingSheet.vue'
import CoachLeave from '@/components/CoachLeave.vue'
import AccountManagement from './components/admin/AccountManagement.vue'
import MenuPermissionManagement from './components/admin/MenuPermissionManagement.vue'
import EditProfile from './components/EditProfile.vue'
import MothersDayOverlay from './components/theme/MothersDayOverlay.vue'
import LoyKrathongOverlay from './components/theme/LoyKrathongOverlay.vue'
import NewYearOverlay from './components/theme/NewYearOverlay.vue'
import SongkranOverlay from './components/theme/SongkranOverlay.vue'
import HalloweenOverlay from './components/theme/HalloweenOverlay.vue'
import ChristmasOverlay from './components/theme/ChristmasOverlay.vue'
import FathersDayOverlay from './components/theme/FathersDayOverlay.vue'
import MuayThaiOverlay from './components/theme/MuayThaiOverlay.vue'
import { mapGetters } from 'vuex';
import LoadingDialog from './components/LoadingDialog.vue';
import NotificationBell from './components/common/NotificationBell.vue';
import SessionGuard from './components/common/SessionGuard.vue';
import live from './utils/live';
import { disablePush, rebindPushToCurrentUser, refreshServiceWorker } from './utils/push';

// ── Frontend menu registry — mirrors MENU_REGISTRY in istarserver_dev/server.js ──
// The sidebar is driven by the server's answer to /getMyMenus (menukey list). `fallback`
// reproduces the pre-permission hardcoded visibility and is used ONLY while /getMyMenus
// hasn't answered or failed (old backend, network hiccup) — the backend enforces the real
// rules on every endpoint regardless of what this renders.
// `value` is the App.vue state; `key` is the backend menukey (they differ only for payment).
// `substates` are sub-flow states reachable from that menu — they inherit its permission.
const MENU_GROUPS = [
  {
    labelKey: 'nav.groupMine',
    items: [
      { value: 'home',       key: 'home',       icon: 'mdi-home-account',     labelKey: 'nav.home',   fallback: (f) => f.manager || f.customer, substates: ['reservation', 'groupreservation'] },
      { value: 'familylist', key: 'familylist', icon: 'mdi-account-multiple', labelKey: 'nav.family', fallback: (f) => f.manager || f.customer, substates: ['addfamilymember'] },
    ],
  },
  {
    labelKey: 'nav.groupOverview',
    items: [
      { value: 'dashboard',   key: 'dashboard',   icon: 'mdi-view-dashboard',    labelKey: 'nav.dashboard',   fallback: (f) => f.manager || f.admin },
      // รายงานเชิงลึก — ผู้จัดการเท่านั้น ตัดสินจาก role ในโค้ด (headOnly) เหมือนหน้าสิทธิ์เมนู
      // เพราะฝั่ง backend เป็น core:'headonly' = มอบให้แอดมินไม่ได้เลย ไม่ใช่แค่ deny-by-default
      // แอดมินใช้ "ตรวจสอบประจำวัน" แทน (ข้อมูลสด + รายการปฏิบัติการครบกว่า)
      { value: 'insightview', key: 'insightview', icon: 'mdi-chart-box-outline', labelKey: 'nav.insightView', fallback: (f) => f.manager, headOnly: true },
      // ตรวจสอบประจำวัน — deny-by-default ฝั่ง backend (ไม่มีแถวใน tmenupermission = head เท่านั้น);
      // head มอบสิทธิ์ให้แอดมินได้ที่หน้าสิทธิ์เมนู แต่โค้ช/ลูกค้าถูกล็อกในโค้ด
      { value: 'opschecklist', key: 'opschecklist', icon: 'mdi-clipboard-alert-outline', labelKey: 'nav.opsChecklist', fallback: (f) => f.manager },
      // AI Chatbot — deny-by-default ฝั่ง backend (head เท่านั้น); head มอบให้แอดมินได้ที่หน้าสิทธิ์เมนู
      // fallback (ใช้เฉพาะช่วงรอ /getMyMenus) = ผู้จัดการ เหมือน opschecklist
      { value: 'chatbot', key: 'chatbot', icon: 'mdi-robot-happy-outline', labelKey: 'nav.chatbot', fallback: (f) => f.manager },
    ],
  },
  {
    labelKey: 'nav.groupSchedule',
    items: [
      { value: 'viewclasses',           key: 'viewclasses',           icon: 'mdi-table-eye',             labelKey: 'nav.viewClasses',              fallback: (f) => f.manager || f.customer || f.coach },
      { value: 'bookingmanager',        key: 'bookingmanager',        icon: 'mdi-calendar-edit',         labelKey: 'nav.bookingManagement',        fallback: (f) => f.manager || f.admin },
      { value: 'privatebookingmanager', key: 'privatebookingmanager', icon: 'mdi-account-heart-outline', labelKey: 'nav.privateBookingManagement', fallback: (f) => f.manager || f.admin },
      // อีเวนต์/แข่งขัน — แยกจากแท็บใน bookingmanager (EVENT_SYSTEM_DESIGN.md §8 เฟส 1)
      { value: 'eventmanager',          key: 'eventmanager',          icon: 'mdi-trophy-outline',        labelKey: 'nav.eventManager',             fallback: (f) => f.manager || f.admin },
    ],
  },
  {
    labelKey: 'nav.groupStudents',
    items: [
      { value: 'gymnastmanager',         key: 'gymnastmanager',         icon: 'mdi-account-group',              labelKey: 'nav.gymnastsAll',    fallback: (f) => f.manager || f.admin },
    ],
  },
  {
    labelKey: 'nav.groupCourses',
    items: [
      { value: 'customercourse',         key: 'customercourse',         icon: 'mdi-book-account',               labelKey: 'nav.customerCourse', fallback: (f) => f.manager || f.admin },
      { value: 'customercoursefinished', key: 'customercoursefinished', icon: 'mdi-clipboard-text-clock',       labelKey: 'nav.courseHistory',  fallback: (f) => f.manager || f.admin },
    ],
  },
  {
    // งานโค้ช/บุคลากร — แยกออกจากกลุ่มการจองเพื่อไม่ให้กลุ่มเดียวยาวเกินไป (mirror MENU_REGISTRY ใน server.js)
    labelKey: 'nav.groupCoach',
    items: [
      // จัดกลุ่มโค้ชในคลาส (แทน Google Sheet เดิม)
      // default = ผู้จัดการ (head) เท่านั้น; head มอบสิทธิ์ให้พนักงานบางคนได้ที่หน้าสิทธิ์เมนู (รายบุคคล)
      { value: 'groupingmanager',       key: 'groupingmanager',       icon: 'mdi-account-group-outline', labelKey: 'nav.grouping',                 fallback: (f) => f.manager },
      { value: 'coachschedule',         key: 'coachschedule',         icon: 'mdi-clipboard-account-outline', labelKey: 'nav.coachSchedule',        fallback: (f) => f.manager || f.admin || f.coach },
      // ยื่นใบลา — สิทธิพนักงานทุกคน (ยื่น/ติดตามใบลาตัวเอง + ดูโควต้าคงเหลือ)
      { value: 'coachleave',            key: 'coachleave',            icon: 'mdi-calendar-clock',            labelKey: 'nav.coachLeave',           fallback: (f) => f.manager || f.admin || f.coach },
      // อนุมัติการลา — งานผู้จัดการ (head เท่านั้น default); head มอบสิทธิ์ให้คนอื่นได้ที่หน้าสิทธิ์เมนู
      { value: 'leaveapproval',         key: 'leaveapproval',         icon: 'mdi-clipboard-check-outline',   labelKey: 'nav.leaveApproval',        fallback: (f) => f.manager },
    ],
  },
  {
    labelKey: 'nav.groupFinance',
    items: [
      // รายงานยอดขาย/การเงิน — default ผู้จัดการเท่านั้น (deny-by-default ฝั่ง backend ไม่มีแถวใน
      // tmenupermission); head มอบสิทธิ์ให้แอดมินได้ที่หน้าสิทธิ์เมนู แต่โค้ช/ลูกค้าถูกล็อกในโค้ด
      { value: 'financereport', key: 'financereport', icon: 'mdi-cash-multiple', labelKey: 'nav.financeReport', fallback: (f) => f.manager },
      // ลงบัญชี Peak (ACCOUNTING_SYNC_DESIGN.md) — ผู้จัดการเท่านั้น ตัดสินจาก role ในโค้ด (headOnly)
      // เพราะฝั่ง backend เป็น core:'headonly' + เช็ค head ซ้ำในทุก endpoint (สั่งสร้างเอกสารบัญชีจริงได้)
      { value: 'accountingsync', key: 'accountingsync', icon: 'mdi-receipt-text-check-outline', labelKey: 'nav.accountingSync', fallback: (f) => f.manager, headOnly: true },
      { value: '__payment', key: 'payment', icon: 'mdi-file-document-multiple-outline', labelKey: 'nav.paymentDocs', fallback: (f) => f.manager, external: true },
    ],
  },
  {
    labelKey: 'nav.groupSetup',
    items: [
      // จัดการคอร์ส + จัดการคลาส เดิม รวมเป็นหน้าเดียว "จัดการตารางเรียน" — ใช้ menukey 'course'
      // ที่ head มีสิทธิ์อยู่แล้ว; state 'classes' เก็บเป็น substate เผื่อ deep-state เดิม (ชี้หน้าเดียวกัน)
      { value: 'course',                key: 'course',                icon: 'mdi-calendar-multiselect',            labelKey: 'nav.scheduleAdmin',     fallback: (f) => f.manager, substates: ['classes'] },
      { value: 'holidaymanager',        key: 'holidaymanager',        icon: 'mdi-calendar-remove',                 labelKey: 'nav.closures',          fallback: (f) => f.manager || f.admin },
      { value: 'accountmanager',        key: 'accountmanager',        icon: 'mdi-account-cog',                     labelKey: 'nav.accountManagement', fallback: (f) => f.manager || f.admin },
      // หน้าจัดการสิทธิ์เมนู — ล็อกไว้ที่ head ในโค้ดเสมอ ไม่ขับด้วย DB (กัน lockout):
      // ต่อให้ข้อมูลสิทธิ์ใน DB เสีย ผู้จัดการก็ยังเข้าหน้านี้มาแก้ได้
      { value: 'menupermissionmanager', key: 'menupermissionmanager', icon: 'mdi-shield-key-outline',              labelKey: 'nav.menuPermission',    fallback: (f) => f.manager, headOnly: true },
    ],
  },
  // ไม่มีกลุ่ม 'บัญชี' ในไซด์บาร์แล้ว — 'editprofile' เข้าจากเมนูรูปโปรไฟล์บนแถบบนทางเดียว
  // (ทางเดิมซ้ำซ้อนกัน); allowedStates ปล่อยผ่านให้ทุกคนที่ล็อกอินแทน ดูคอมเมนต์ที่นั่น
];
const MENU_ITEM_BY_VALUE = Object.fromEntries(
  MENU_GROUPS.flatMap((g) => g.items).map((it) => [it.value, it])
);

// ── URL ต่อหน้า (?page=<state>) — ให้คลิกขวาเปิดแท็บใหม่ / รีเฟรชแล้วอยู่หน้าเดิม / ปุ่ม Back ใช้ได้ ──
// ใช้ query ไม่ใช้ path (/bookingmanager) โดยตั้งใจ: static site บน DO ไม่มี catchall แล้ว
// (เอาออกตอนแก้จอขาวหลัง deploy) path ที่ไม่ใช่ไฟล์จริงจะได้ 404
//
// 🔑 URL เป็นแค่ "คำขอ" ไม่ใช่สิทธิ์ — ทุกทางที่อ่าน URL แล้วพาไปหน้า (ตอนบูต · ปุ่ม Back) ต้องผ่าน
// isStateAllowed ก่อนเสมอ ส่วน watch(state) มีหน้าที่ "เขียน" URL ตามหน้าที่เปิดอยู่เท่านั้น
//
// หน้าที่เปิดตรงจาก URL ได้ = เมนูในทะเบียน (ไม่นับลิงก์ภายนอก) + หน้าโปรไฟล์ · substate
// (reservation / addfamilymember / classes …) ไม่มี URL ของตัวเอง เพราะต้องพกบริบทมาจากหน้าแม่
// (เช่น นักเรียนที่เลือกไว้ใน Home) — ใช้ URL ของหน้าแม่ รีโหลดแล้วจึงกลับไปหน้าแม่
const URL_PAGES = new Set([
  ...MENU_GROUPS.flatMap((g) => g.items).filter((it) => !it.external).map((it) => it.value),
  'editprofile',
]);
const SUBSTATE_PARENT = Object.fromEntries(
  MENU_GROUPS.flatMap((g) => g.items).flatMap((it) => (it.substates || []).map((s) => [s, it.value]))
);
const AUTH_STATES = ['login', 'register', 'forgotpassword'];
function pageOfState(state) {
  const page = SUBSTATE_PARENT[state] || state;
  return URL_PAGES.has(page) ? page : null;
}
// คืนเฉพาะค่าที่รู้จัก — ?page=อะไรก็ได้ที่พิมพ์มาเองถือว่าไม่มี
function readPageFromUrl() {
  try {
    const page = new URLSearchParams(window.location.search).get('page');
    return page && URL_PAGES.has(page) ? page : null;
  } catch (e) { return null; }
}
// หน้าต่างที่ "แยกออกมา" จากปุ่ม ↗ (popOut) — ?embed=1 = เหลือแต่เนื้อหาหน้า ไม่มีไซด์เมนู/แถบบน/
// แท็บล่าง/กระดิ่ง/FAB · อ่านครั้งเดียวตอนบูต และ urlWithPage คง embed ไว้เมื่อเดินหน้าในหน้าต่างนั้น
// ต้องเป็นบานที่ popOut เปิดจริงด้วย (ชื่อหน้าต่างขึ้นต้น POPUP_NAME_PREFIX — window.name อยู่รอดการรีโหลด
// และการเดินหน้าในบานนั้น) ไม่ใช่แค่ URL มี embed=1: ก๊อป URL ไปเปิดในแท็บปกติ/บุ๊กมาร์กไว้ จะได้แอปเต็ม
// ไม่ใช่หน้าที่ไม่มีเมนู ไม่มีปุ่มออกจากระบบ และ window.close() ใช้ไม่ได้ (แท็บที่สคริปต์ไม่ได้เปิด)
const POPUP_NAME_PREFIX = 'istar-pop-';
function readEmbedFromUrl() {
  try {
    return new URLSearchParams(window.location.search).get('embed') === '1'
      && String(window.name || '').startsWith(POPUP_NAME_PREFIX);
  } catch (e) { return false; }
}
// หน้าต่างแยกที่บานนี้เปิดไว้ (ต่อหน้า) — กด ↗ ซ้ำหน้าเดิม = โฟกัสบานเดิม ไม่เปิดบานใหม่ซ้อน
// (ทุกบานต่อสายเรียลไทม์ของตัวเอง เพดาน 5 สาย/คน) · ไม่เก็บใน data เพราะไม่ต้องการให้ Vue ห่อ proxy
const popupWindows = {};
// คง query อื่นไว้ (เช่น ?nk= ของการ์ดแจ้งเตือนที่ยังไม่ถูกอ่าน) แก้เฉพาะ page
function urlWithPage(page) {
  const q = new URLSearchParams(window.location.search);
  if (page) q.set('page', page); else q.delete('page');
  const rest = q.toString();
  return window.location.pathname + (rest ? '?' + rest : '') + window.location.hash;
}

// Single source of truth for the theme ids. There used to be THREE lists that drifted apart:
// themeOptions offered 9 themes, fetchGlobalTheme only accepted 3, and the backend whitelist in
// /saveAppSettings accepted the same 3 — so picking any of the other 6 returned HTTP 400, which
// saveGlobalTheme swallowed silently. The head saw the theme apply locally and never learned it
// had not been saved for anyone else. Keep this in sync with the whitelist in server.js
// (/saveAppSettings) and with the html.theme-<id> blocks in istar-themes.css.
// 'default' = no class at all (the :root pink baseline), hence FESTIVAL_THEME_IDS separately.
// จุดตัดจอแคบ — ตรงกับ @media (max-width:900px) ใน istar-pages.css ที่คุมไซด์บาร์/แท็บล่างอยู่แล้ว
// (แท็บเล็ตไม่มี tier แยก ตกไปฝั่งใดฝั่งหนึ่งของเส้นนี้)
const NARROW_BP = 900;
// เมนูไม่เกินจำนวนนี้บนจอแคบ = ใช้แท็บล่าง เกินกว่านี้สลับเป็นไซด์เมนูอัตโนมัติ
const BOTTOM_TAB_MAX = 4;
const FESTIVAL_THEME_IDS = ['mothersday', 'loykrathong', 'newyear', 'songkran', 'halloween', 'christmas', 'fathersday', 'muaythai'];
const THEME_IDS = ['default', ...FESTIVAL_THEME_IDS];

export default {
  data() {
    return {
      drawer: false,
      userProfileImage: null,
      rail: false,
      parent: 'Guest',
      state: 'login',
      black: false,
      blackstate: 'home',
      homestate: 'family',
      errorDialog: false,
      errorMsg: '',
      successDialog: false,
      inforMsg: '',
      userdata: {},
      student: null,
      managerflag: false,
      adminflag: false,
      coachflag: false,
      customerflag: false,
      // สิทธิ์เมนูจาก /getMyMenus (null = ยังไม่ได้คำตอบ/ล้มเหลว → navGroups ใช้ fallback เดิม)
      myMenus: null,
      // วันของนัดหมายที่ผู้ใช้กดมาจากการ์ดแจ้งเตือน — ส่งเป็น prop ให้หน้าปลายทางเปิดที่วันนั้น
      // ถูกล้างทันทีที่ผู้ใช้เดินเมนูเอง (กดเมนูปกติ = ต้องได้หน้าของ "วันนี้" ตามที่คาด)
      notifyDate: null,
      // ปลายทางที่ติดมากับ URL ตอนเปิดแอปจาก push (รอจนล็อกอินเสร็จค่อยพาไป)
      pendingNoti: null,
      // หน้าที่ขอมาทาง ?page= ตอนเปิดแอป — อ่านใน created() ใช้ใน AffterLogin (หลังรู้ว่าเป็นใคร)
      pendingPage: null,
      // หน้าที่ขอมาแต่ fallback ของ role ยังไม่ให้ผ่าน (เช่น แอดมินที่หัวหน้ามอบเมนูพิเศษให้)
      // รอคำตอบ /getMyMenus ก่อนค่อยตัดสิน · ระหว่างนี้ห้ามเขียน URL ทับ ไม่งั้นคำขอหาย
      deferredPage: null,
      deferredLanding: null,   // หน้าแรกตาม role — ไปที่นี่ถ้า deferredPage เข้าไม่ได้
      // เด้งออกจากหน้าที่ไม่มีสิทธิ์ = แทนที่ประวัติ ไม่ใช่เพิ่ม (กด Back แล้วต้องไม่วนกลับไปหน้าที่เข้าไม่ได้)
      replaceNextUrl: false,
      // หน้าต่างแยก (?embed=1) — ดู readEmbedFromUrl
      embed: typeof window !== 'undefined' && readEmbedFromUrl(),
      hasHoverPointer: typeof window !== 'undefined' && !!window.matchMedia
        && window.matchMedia('(hover: hover)').matches,
      bookingAccessRestricted: false,
      interval: null,
      ConfirmLogoutDialog: false,
      loadingDialog: false,
      isLoading: false,
      collapsed: false,
      // ความกว้างจอ — ใช้ตัดสินว่าเป็นรูปแบบที่ 1 (แท็บล่าง) หรือ 2 (ไซด์เมนู)
      // ต้องเป็น reactive ไม่ใช่อ่าน window.innerWidth ตรง ๆ ใน computed ไม่งั้นหมุนจอ/ย่อ
      // หน้าต่างแล้ว layout ไม่เปลี่ยนตาม (computed ไม่รู้ว่าต้องคำนวณใหม่)
      viewportW: typeof window !== 'undefined' ? window.innerWidth : 1280,
      // collapsed-rail hover hint (the ONE floating .nav-tip) — fixed-position so the
      // scrollable rail can't clip it; positioned from the hovered item's rect
      navTip: { show: false, text: '', x: 0, y: 0 },
      // Per-group sidebar collapse — keyed by the group's stable labelKey (NOT array index /
      // translated label) so state survives language switches and permission-driven group changes.
      // A key present with a truthy value = collapsed; absent = expanded (default: all groups open).
      collapsedGroups: (() => {
        try {
          const raw = localStorage.getItem('sidebarCollapsedGroups');
          const arr = raw ? JSON.parse(raw) : [];
          return Array.isArray(arr) ? Object.fromEntries(arr.map((k) => [k, true])) : {};
        } catch (e) { return {}; }
      })(),
      // โลโก้แทนอวตาร์ของคนที่ยังไม่ได้ตั้งรูปโปรไฟล์ — ไฟล์อยู่ใน public/ (ไม่ผ่าน webpack import)
      // จึงอ้างด้วย path ตรง ๆ ระบบ deploy ที่ root เสมอ ไม่มี BASE_URL subpath ให้ต้องเผื่อ
      istarLogo: '/assets/iStar_InvertLogo.jpg',
      // seasonal theme — persisted per-browser in localStorage (no backend sync)
      uiTheme: localStorage.getItem('uiTheme') || 'default',
      // โหมดมืดของ "เครื่องผู้ใช้" (ไม่ใช่ค่าที่เลือกในแอป — เจ้าของเคาะว่าไม่มีปุ่มให้เลือก
      // 2026-08-05) · อ่านค่าตั้งต้นตรงนี้เลยเพื่อไม่ให้จอสว่างวาบก่อนแล้วค่อยมืดตอน mounted
      prefersDark: typeof window !== 'undefined' && !!window.matchMedia
        && window.matchMedia('(prefers-color-scheme: dark)').matches,
      themeMenu: false,
      userMenu: false,
      // twinkling stars rendered inside the side menu only (background decoration)
      sparks: Array.from({ length: 14 }, (_, i) => ({
        x: [10, 26, 16, 34, 8, 28, 46, 60, 80, 90, 70, 88, 78, 92][i],
        y: [12, 28, 52, 72, 86, 94, 18, 8, 14, 30, 44, 58, 76, 88][i],
        sz: 12 + (i % 4) * 5,
        o: 0.4 + (i % 3) * 0.18,
        d: ((i * 0.33) % 3).toFixed(2),
        dur: 2.4 + (i % 4) * 0.5,
      })),
    }
  },
  watch: {
    drawer(newVal) {
      console.log('Drawer state changed to:', newVal);
    },
    // ทุกทางที่เปลี่ยนหน้า (เมนู · ปุ่มในหน้า · ตั้ง state ตรง ๆ ใน AffterLogin/fetchMyMenus) ผ่านตรงนี้
    // จึงเขียน URL ที่จุดเดียว — "เขียน" อย่างเดียว ห้ามใช้ watcher นี้ตัดสินว่าจะไปหน้าไหน
    // เปลี่ยนภาษาแล้วชื่อแท็บ/หน้าต่างต้องเปลี่ยนตาม ไม่ใช่รอกดเมนูครั้งถัดไป
    '$i18n.locale'() {
      this.updateDocTitle();
    },
    state(newState, oldState) {
      // ม่านโหลดเป็นของ "หน้า" — หน้าที่ถูกถอดไปแล้วปิดม่านของตัวเองไม่ได้ (Vue 3 ทิ้ง emit ของ
      // component ที่ unmount แล้ว) เช่น กดเมนูอื่นขณะแดชบอร์ดยังโหลดไม่เสร็จ = "Loading..." ค้างบัง
      // ทั้งจอจนต้องรีเฟรช · ล้างตอนเปลี่ยนหน้าปลอดภัย: watcher นี้รันก่อน render หน้าใหม่ หน้าใหม่ที่
      // เปิดม่านใน created() จึงเปิดทับหลังจากนี้ได้ตามปกติ
      this.isLoading = false;
      this.syncUrlToState(newState);
      this.updateDocTitle();
      // หน้าต่างแยกที่ถูกพา "ออกจากระบบ" (จากหน้าที่ล็อกอินอยู่ → หน้าล็อกอิน) ใช้ต่อไม่ได้แล้ว — ปิดตัวเอง
      // ต้องเช็คว่ามาจากหน้าที่ล็อกอินอยู่: บานที่เปิดมาแล้วยังไม่ล็อกอิน ผู้ใช้กด "สมัครสมาชิก" /
      // "ลืมรหัสผ่าน" (login → register) ต้องไม่ปิดใส่หน้า · ปิดไม่ได้ (เบราว์เซอร์ไม่ยอม) = เหลือหน้า
      // ล็อกอินที่ URL/ชื่อหน้าถูกล้างแล้วตามปกติ
      if (this.embed && AUTH_STATES.includes(newState) && !AUTH_STATES.includes(oldState)) window.close();
    },
  },
  name: 'App',
  components: {
    NotificationBell,
    SessionGuard,
    Login,
    ForgotPassword,
    Register,
    Reservation,
    GroupReservation,
    Home,
    ViewClasses,
    FamilyList,
    AddFamily,
    Dashboard,
    InsightView,
    OpsChecklist,
    ChatbotView,
    ChatbotFab,
    FinanceReport,
    AccountingSync,
    GymnastManagement,
    BookingManagement,
    PrivateBookingManagement,
    EventManager,
    CustomerCourse,
    CustomerCourseFinished,
    ScheduleAdmin,
    ClosureManagement,
    GroupingSheet,
    CoachLeave,
    AccountManagement,
    MenuPermissionManagement,
    EditProfile,
    MothersDayOverlay,
    LoyKrathongOverlay,
    NewYearOverlay,
    SongkranOverlay,
    HalloweenOverlay,
    ChristmasOverlay,
    FathersDayOverlay,
    MuayThaiOverlay,
    LoadingDialog,
  },
  methods: {
    // delegated mouseover on the whole <aside> — cheap, and covers every .nav-item
    // (group items + collapse-toggle + logout) without per-item listeners
    onSideNavHover(e) {
      if (!this.collapsed) { this.hideNavTip(); return; }
      const item = e.target.closest('.nav-item');
      const label = item && item.dataset.label;
      if (!label) { this.hideNavTip(); return; }
      const r = item.getBoundingClientRect();
      this.navTip = { show: true, text: label, x: r.right + 12, y: r.top + r.height / 2 };
    },
    hideNavTip() {
      if (this.navTip.show) this.navTip.show = false;
    },
    onViewportResize() {
      this.viewportW = window.innerWidth;
    },
    // แตะโปรไฟล์: จอแคบเปิดแผ่นเลื่อนขึ้นให้เลือก (แก้ไข/ออกจากระบบ/ยกเลิก) ตามสเปก
    // จอกว้างไปหน้าแก้ไขข้อมูลตรง ๆ เพราะ "ออกจากระบบ" มีปุ่มอยู่ท้ายไซด์เมนูให้เห็นอยู่แล้ว
    onProfileTap() {
      if (this.isNarrow) { this.userMenu = true; return; }
      this.onClickChangeState('editprofile');
    },
    isGroupCollapsed(key) {
      return !!this.collapsedGroups[key];
    },
    toggleGroup(key) {
      // ในโหมดย่อทั้งแถบ (mini-rail) หัวกลุ่มเป็นแค่เส้นคั่น ไม่มีความหมายที่จะหุบรายกลุ่ม — ข้ามไป
      if (this.collapsed) return;
      // reassign object ใหม่เพื่อการันตี reactivity (รองรับคีย์ที่เพิ่งเกิดครั้งแรก)
      this.collapsedGroups = { ...this.collapsedGroups, [key]: !this.collapsedGroups[key] };
      try {
        const collapsed = Object.keys(this.collapsedGroups).filter((k) => this.collapsedGroups[k]);
        localStorage.setItem('sidebarCollapsedGroups', JSON.stringify(collapsed));
      } catch (e) { /* storage unavailable */ }
    },
    async AffterLogin() {
      this.userdata = JSON.parse(localStorage.getItem('userdata'))
      //console.log("userdata", this.userdata);
      if(this.userdata) {
        this.parent = this.userdata.firstname
        this.student = null;
        this.bookingAccessRestricted = !!this.userdata.access_restricted;
        this.myMenus = null;       // เคลียร์สิทธิ์ของ user ก่อนหน้า — ใช้ fallback จนกว่าคำตอบใหม่จะมา
        this.fetchUserProfileImage();
        this.fetchGlobalTheme();   // pick up the head-controlled global theme on login
        this.fetchMyMenus();       // fire-and-forget — navGroups reactive จะปรับเมนูเองเมื่อได้คำตอบ
        this.rebindPush();         // ย้ายเจ้าของ Web Push subscription มาเป็นคนที่เพิ่งล็อกอิน
        // เปิดสายเรียลไทม์ · อ่านโทเคนจาก store ทุกครั้ง (ไม่จำค่าไว้) เพราะมันเปลี่ยนทุกครั้ง
        // ที่ต่ออายุ — จำไว้ตั้งแต่ตอนนี้ = ขอตั๋วด้วยใบที่หมดอายุแล้วหลังผ่านไปครึ่งชั่วโมง
        live.start(() => this.$store.getters.getToken);
        // ล้าง flag ของคนก่อนในแท็บเดียวกันก่อนเสมอ — เดิมล้างแค่ใน logout() ทางหมดอายุที่เด้งกลับ
        // หน้าล็อกอินไม่ได้ล้าง คนถัดไปจึงได้ fallback (รวมเมนู headOnly) ของคนก่อนติดมา
        this.managerflag = false;
        this.adminflag = false;
        this.coachflag = false;
        this.customerflag = false;
        // URL แรกหลังล็อกอินต้อง "แทนที่" เสมอ — แท็บนี้อาจยังมี ?page= ของคนก่อน (กด Back ที่หน้าล็อกอิน)
        // ถ้าเพิ่มต่อ คนนี้กด Back ครั้งแรกจะถูกพาไปหน้าของคนก่อน
        const stateBefore = this.state;
        this.replaceNextUrl = true;
        this.deferredPage = null;
        this.deferredLanding = null;
        this.black = false;   // ปุ่มย้อนกลับบนแถบบนของคนก่อน (initBack) ไม่ติดมา
        if (this.userdata.usertype == 0) { // head
          this.managerflag = true
          this.state = 'dashboard'
        } else if (this.userdata.usertype == 1) { // admin
          this.adminflag = true
          this.state = 'dashboard'
        } else if (this.userdata.usertype == 2) { // coach
          this.coachflag = true
          // landing โค้ช = ตารางสอนของฉัน (กลุ่มที่ผู้จัดการจัดไว้); ถ้าสิทธิ์ถูกปิด
          // fetchMyMenus จะเด้งไปเมนูแรกที่เข้าได้เอง
          this.state = 'coachschedule'
        } else { // customer
          this.customerflag = true
          this.state = 'home'
        }
        // เปิดแอปมาจากการกดการ์ด push ตอนที่แอปยังไม่เปิดอยู่ — พาไปหน้า/วันที่ถูกแจ้ง
        // ต้องทำ "หลัง" ตั้ง state ตาม role เสร็จแล้ว ไม่งั้นจะถูกเขียนทับ
        const wantPage = this.pendingPage;
        this.pendingPage = null;
        if (this.pendingNoti) {
          const p = this.pendingNoti;
          this.pendingNoti = null;
          this.$nextTick(() => {
            // หน้าแรกตาม role ไม่ใช่สิ่งที่ผู้ใช้เลือก — ไม่ทิ้งไว้ในประวัติ · ถ้าการ์ดไม่พาไปไหน
            // (ไม่มีปลายทาง/อยู่หน้านั้นอยู่แล้ว) ต้องปลดธง ไม่งั้นการกดเมนูครั้งถัดไปจะแทนที่แทนเพิ่ม
            const before = this.state;
            this.replaceNextUrl = true;
            this.openFromNotification(p);
            if (this.state === before) this.replaceNextUrl = false;
          });
        } else if (wantPage && wantPage !== this.state) {
          // เปิดมาจากลิงก์ ?page= (แท็บใหม่ / รีเฟรช) — **รอสิทธิ์จริงจาก /getMyMenus ก่อนเสมอ**
          // ไม่ตัดสินจาก fallback ของ role ตอนนี้: ถ้า fallback ให้ผ่านแต่หัวหน้าปิดเมนูนั้นไว้ หน้าจะ
          // mount แล้วยิง API ไปโดน 403 = dialog "ไม่มีสิทธิ์" เด้งใส่หรือไม่ ขึ้นกับว่าคำตอบไหนมาก่อน
          // ระหว่างรอ = หน้าว่าง (state '' ไม่ตรงกับ v-if ไหน) **ห้าม mount หน้าแรกตาม role ไว้ก่อน**:
          // เคยทำแล้วแดชบอร์ดเปิดม่านโหลดตอน created แล้วถูกถอดก่อนปิดม่าน (Vue ทิ้ง emit ของ
          // component ที่ unmount แล้ว) = ม่าน "Loading..." ค้างบังทั้งจอ + ยิง API ของหน้าแรกทิ้งฟรี
          this.deferredLanding = this.state;
          this.deferredPage = wantPage;
          this.state = '';
        }
        // ล็อกอินซ้ำโดยหน้าไม่เปลี่ยน (watcher ไม่ยิง) = ธงไม่ถูกใช้ ปลดทิ้ง ไม่งั้นค้างไปแทนที่ประวัติ
        // ตอนผู้ใช้กดเมนูครั้งถัดไป
        if (this.state === stateBefore) this.replaceNextUrl = false;
      }else {
        // ไม่มี userdata = สถานะค้างที่ไม่สมบูรณ์ (token เหลืออยู่แต่ข้อมูลผู้ใช้หาย)
        // ต้องล้าง token ทิ้งด้วย ไม่งั้นรีเฟรชครั้งหน้าจะวนกลับมาที่นี่อีกไม่รู้จบ
        localStorage.removeItem('token');
        this.$store.dispatch('logout');
        this.state = 'login'
      }
    },
    // เครื่องที่เปลี่ยนมือ: โค้ช A เปิดแจ้งเตือนไว้แล้วปิดเบราว์เซอร์ไปเฉย ๆ (ไม่ได้กด logout)
    // จากนั้นโค้ช B มาล็อกอินบนเครื่องเดียวกัน — subscription เดิมยังผูกกับ A อยู่ B จึงจะเห็น
    // แจ้งเตือนคาบของ A เด้งขึ้นมา · ยิงบันทึกซ้ำตรงนี้ = upsert ย้ายเจ้าของมาเป็น B
    // ไม่มี subscription อยู่ก่อน = ไม่ทำอะไร (ไม่ขอสิทธิ์แจ้งเตือนเองโดยผู้ใช้ไม่ได้สั่ง)
    async rebindPush() {
      const token = this.$store.getters.getToken;
      if (!token) return;
      await rebindPushToCurrentUser({
        save: (sub) => axios.post(this.baseURL + '/savePushSubscription', sub,
          { headers: { Authorization: `Bearer ${token}` } }),
      });
    },
    async fetchUserProfileImage() {
      // clear first so a previous user's photo never lingers when switching accounts
      // (a new user with no photo would otherwise keep showing the old avatar)
      this.userProfileImage = null;
      try {
        const userdata = JSON.parse(localStorage.getItem('userdata'));
        if (!userdata || !userdata.username) return;
        const token = this.$store.getters.getToken;
        const res = await axios.post(
          this.baseURL + '/getUserProfile',
          { username: userdata.username },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data && res.data.success && res.data.user && res.data.user.profile_image_url) {
          this.userProfileImage = res.data.user.profile_image_url;
        }
      } catch (e) {
        // backend ยังไม่รองรับ — ใช้รูป default
      }
    },
    onProfileImageUpdated(url) {
      this.userProfileImage = url;
    },
    // ดึงรายการเมนูที่ user นี้เข้าได้จาก server (ตาม tmenupermission) — ล้มเหลวก็เงียบไว้:
    // navGroups จะใช้ fallback (พฤติกรรมเดิม) และ backend ยังบังคับสิทธิ์ทุก endpoint อยู่แล้ว
    async fetchMyMenus() {
      try {
        const token = this.$store.getters.getToken;
        // มี timeout เพราะหน้าที่ขอมาทาง URL รอคำตอบนี้อยู่ (deferredPage) — ค้างไม่รู้จบ = URL ไม่ขยับทั้งเซสชัน
        const res = await axios.post(this.baseURL + '/getMyMenus', {}, {
          headers: { Authorization: 'Bearer ' + token },
          timeout: 15000,
        });
        // คำตอบมาถึงหลังผู้ใช้ออกจากระบบไปแล้ว — ไม่เอาเมนูของคนที่ออกไปมาค้างไว้
        if (this.isAuthScreen) return;
        if (res.data && res.data.success && Array.isArray(res.data.menukeys)) {
          this.myMenus = res.data.menukeys; // array of allowed menukey strings
          // หน้าที่ขอมาทาง URL แล้วรอสิทธิ์จริงอยู่ (ดู AffterLogin) — ตัดสินตอนนี้
          this.resolveDeferredPage();
          // state ปัจจุบันอาจถูกริบสิทธิ์ไปแล้ว (เช่น แอดมินที่โดนปิด dashboard) — เด้งไปเมนูแรกที่เข้าได้
          if (!this.isStateAllowed(this.state)) {
            const first = this.navGroups.flatMap((g) => g.items).find((i) => !i.external);
            this.replaceNextUrl = true;
            this.state = first ? first.value : 'editprofile';
          }
        }
      } catch (e) {
        // backend เก่า / เครือข่ายมีปัญหา — คงเมนูตาม fallback เดิม
      } finally {
        // ยังค้างอยู่ = ไม่ได้คำตอบ (backend เก่า/เน็ตล้ม) → myMenus ยังเป็น null จึงตัดสินด้วย
        // fallback ของ role เหมือนที่ไซด์เมนูทำ · ไม่ปลดตรงนี้ = หน้าว่างค้าง + URL ไม่ขยับทั้งเซสชัน
        this.resolveDeferredPage();
        this.syncUrlToState(this.state, { replace: true });
      }
    },
    // ตัดสินหน้าที่ขอมาทาง URL: เข้าได้ = ไปหน้านั้น · ไม่ได้ = หน้าแรกตาม role (เงียบ ๆ ไม่ขึ้น dialog)
    // แทนที่ประวัติเสมอ — รายการ ?page= ที่ขอมาคือรายการเดียวกับหน้าที่ได้จริง
    resolveDeferredPage() {
      const want = this.deferredPage;
      const landing = this.deferredLanding;
      if (!want) return;
      this.deferredPage = null;
      this.deferredLanding = null;
      // ออกจากระบบไประหว่างรอแล้ว (คำตอบ /getMyMenus ที่ยิงไว้ตอนยังล็อกอินมาถึงทีหลัง)
      // ห้ามพาไปไหนต่อ ไม่งั้นเชลล์+หน้ากลับมาให้คนที่ออกไปแล้ว
      if (this.isAuthScreen || !this.$store.getters.getToken) return;
      this.replaceNextUrl = true;
      this.state = this.isStateAllowed(want) ? want : landing;
    },
    // ── URL ต่อหน้า (ดูหัวข้อ URL_PAGES ด้านบน) ───────────────────────────────────────
    pageHref(state) {
      return window.location.pathname + '?page=' + encodeURIComponent(state);
    },
    // คลิกซ้ายธรรมดา = สลับหน้าในแอปเหมือนเดิม (ไม่โหลดใหม่) · กดค้าง Ctrl/⌘/Shift/Alt = ปล่อยให้
    // เบราว์เซอร์ทำเอง (แท็บใหม่/หน้าต่างใหม่/ดาวน์โหลด) · คลิกกลางไม่ยิง click อยู่แล้ว (เป็น auxclick)
    onNavClick(e, it) {
      if (it.external) { e.preventDefault(); this.openPaymentSystem(); return; }
      // ไม่ปล่อย Alt: Chrome/Edge บน Windows ถือว่า Alt+คลิกลิงก์ = ดาวน์โหลดไฟล์ (ได้ index.html มาแทนหน้า)
      if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
      e.preventDefault();
      this.onClickChangeState(it.value);
    },
    // ปุ่ม ↗ "เปิดในหน้าต่างแยก" — หน้าต่างเล็กไม่มีแถบเบราว์เซอร์ (popup) ที่เหลือแต่เนื้อหา
    // (?embed=1) หน้าต่างเดิมกดเมนูอื่นต่อได้ · ต้องเรียกในตัวจัดการคลิกตรง ๆ ห้ามหลัง await
    // ไม่งั้นตัวบล็อกป๊อปอัปถือว่าไม่ได้มาจากการกดของผู้ใช้ · สิทธิ์ตรวจซ้ำในหน้าต่างใหม่ตามปกติ
    popOut(state) {
      const page = pageOfState(state);
      if (!page) return;
      const scr = window.screen || {};
      const w = Math.min(1200, Math.round((scr.availWidth || 1280) * 0.6));
      const h = Math.min(900, Math.round((scr.availHeight || 900) * 0.85));
      const name = POPUP_NAME_PREFIX + page;
      const existing = popupWindows[name];
      if (existing && !existing.closed) { existing.focus(); return; }
      const url = window.location.pathname + '?page=' + encodeURIComponent(page) + '&embed=1';
      // ไม่ใช้ 'noopener': หน้าต่างที่เปิดแบบนั้นไม่นับว่า "เปิดโดยสคริปต์" ใน Firefox พอมีประวัติ
      // มากกว่า 1 รายการ window.close() ตอนออกจากระบบจะถูกเมิน · ตัด opener ทิ้งเองแทน (โดเมนเดียวกัน
      // อยู่แล้ว noopener ไม่ได้ช่วยเรื่องความปลอดภัย) · ชื่อหน้าต่าง = ป้ายบอกว่าเป็นบานแยกจริง (readEmbedFromUrl)
      const win = window.open(url, name, `popup,width=${w},height=${h}`);
      if (win) {
        popupWindows[name] = win;
        try { win.opener = null; } catch (e) { /* ไม่เป็นไร */ }
        try { win.focus(); } catch (e) { /* ไม่เป็นไร */ }
      }
    },
    // ชื่อแท็บ/หน้าต่าง = ชื่อหน้าที่เปิดอยู่ — เปิดหลายแท็บ/หลายหน้าต่างแล้วแยกออกว่าบานไหนคืออะไร
    updateDocTitle() {
      const page = pageOfState(this.state);
      const def = page && MENU_ITEM_BY_VALUE[page];
      const label = def ? this.$t(def.labelKey) : (page === 'editprofile' ? this.$t('nav.editProfile') : '');
      document.title = label ? `${label} · iStar Gymnastics` : 'iStar Gymnastics';
    },
    // ออกจากระบบจากหน้าต่างหลัก → token ถูกลบ → หน้าต่างแยกปิดตาม (แทนที่จะค้างหน้าล็อกอินซ้อน)
    onEmbedStorage(e) {
      if (this.embed && e.key === 'token' && !e.newValue) window.close();
    },
    // ลิงก์เมนูกด Tab ไปถึงได้ (div เดิมไม่ได้) — ตัดตัวที่มองไม่เห็นออกจากลำดับ Tab: กลุ่มที่หุบอยู่
    // (โหมด mini-rail กางทุกกลุ่มให้เองจึงไม่นับ) และลิ้นชักมือถือที่ปิดอยู่ (เลื่อนออกนอกจอ)
    navItemHidden(groupKey) {
      const miniRail = this.collapsed && !this.isNarrow;   // กฎ mini-rail มีเฉพาะจอ >900px
      return (!miniRail && this.isGroupCollapsed(groupKey)) || (this.isNarrow && !this.drawer);
    },
    // อ่านตอนบูต (created) — ยังไม่รู้ว่าเป็นใคร จึงแค่จำไว้ ให้ AffterLogin ตัดสินพร้อมสิทธิ์
    capturePageFromUrl() {
      this.pendingPage = readPageFromUrl();
      // embed=1 ติดมาในแท็บปกติ (ก๊อปลิงก์ของหน้าต่างแยก) — ล้างทิ้ง ไม่งั้น urlWithPage พกมันต่อไปทุกหน้า
      // แล้วลิงก์ที่ก๊อปต่อจากแท็บนี้ก็จะติดไปด้วย
      if (!this.embed) {
        try {
          const q = new URLSearchParams(window.location.search);
          if (q.has('embed')) {
            q.delete('embed');
            const rest = q.toString();
            window.history.replaceState(null, '',
              window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
          }
        } catch (e) { /* ไม่เป็นไร */ }
      }
    },
    // เขียน URL ให้ตรงกับหน้าที่เปิดอยู่ · ครั้งแรกหลังล็อกอิน (URL ยังไม่มี page) = แทนที่
    // ไม่ใช่เพิ่ม ไม่งั้นกด Back ครั้งแรกจะได้ URL เปล่าที่ไม่พาไปไหน
    syncUrlToState(state, opts) {
      if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return;
      try {
        if (AUTH_STATES.includes(state)) {
          // ออกจากระบบ/หน้าล็อกอิน — ไม่ทิ้งหน้าของคนก่อนไว้ใน URL ให้คนถัดไปล็อกอินแล้วเด้งไปหา
          // (อยู่ก่อนเช็ค deferredPage: ออกจากระบบระหว่างรอสิทธิ์ก็ต้องล้าง)
          if (new URLSearchParams(window.location.search).has('page')) {
            window.history.replaceState(null, '', urlWithPage(null));
          }
          return;
        }
        if (this.deferredPage) return;   // ยังรอตัดสินหน้าที่ขอมา — อย่าเขียนทับคำขอ
        const replaceOnce = this.replaceNextUrl;
        this.replaceNextUrl = false;
        const page = pageOfState(state);
        if (!page) return;
        const current = readPageFromUrl();
        if (current === page) return;
        const url = urlWithPage(page);
        if (!current || replaceOnce || (opts && opts.replace)) window.history.replaceState(null, '', url);
        else window.history.pushState(null, '', url);
      } catch (e) { /* history ใช้ไม่ได้ (iframe sandbox บางแบบ) — แอปยังใช้ได้ แค่ไม่มี URL ต่อหน้า */ }
    },
    // ปุ่ม Back/Forward ของเบราว์เซอร์ — URL มาจากผู้ใช้ จึงผ่านด่านสิทธิ์เหมือนกดเมนู
    // เข้าไม่ได้ = คงหน้าเดิมไว้แล้วแก้ URL ให้ตรงกับที่เห็น (ไม่ขึ้น dialog "ไม่มีสิทธิ์" ใส่หน้า)
    onPopState() {
      // หน้าล็อกอิน: กด Back กลับไปเจอรายการประวัติของคนก่อน — ล้าง page ทิ้ง ไม่ให้ค้างอยู่ใน URL
      // แล้วถูกอ่านเป็นหน้าแรกของคนถัดไป
      if (this.isAuthScreen) { this.syncUrlToState(this.state); return; }
      // ยังรอสิทธิ์ของหน้าจากลิงก์อยู่ (ปกติไม่ถึงวินาที) — เมิน Back/Forward ช่วงนี้ไปเลย ง่ายกว่า
      // ตัดสินซ้อนกันสองทาง และ fetchMyMenus จะทำให้ URL ตรงกับหน้าจริงเองตอนจบ
      if (this.deferredPage) return;
      const page = readPageFromUrl();
      if (page === pageOfState(this.state)) return;
      // ?page= ที่ไม่รู้จัก/ไม่มี = ไม่พาไปไหน แต่แก้ URL ให้ตรงกับหน้าที่เห็นอยู่
      if (!page) { this.syncUrlToState(this.state, { replace: true }); return; }
      if (this.isStateAllowed(page)) this.onClickChangeState(page);
      else this.syncUrlToState(this.state, { replace: true });
    },
    toggleRail(page) {
      this.$router.push('/' + page)
    },
    collectData(student) {
      this.student = student
    },
    // ทุก state ที่ยังไม่ login ต้องผ่านได้เสมอ (ไม่มี role ให้เช็คตอนนั้น)
    isStateAllowed(state) {
      if (['login', 'register', 'forgotpassword'].includes(state)) return true;
      return this.allowedStates.has(state);
    },
    // opts.keepNotifyDate = true เฉพาะตอนมาจากการ์ดแจ้งเตือน (ดู openFromNotification)
    onClickChangeState(state, opts) {
      console.log('onClickChangeState called with state:', state);
      if (state == 'login') {
        // 🔑 **โทเคนหมดอายุ ≠ ออกจากระบบ** — ทุกจอในระบบเรียกทางนี้เมื่อเจอ 401 (มีเป็นสิบจุด
        // ต่อจอ) ซึ่งเดิมแปลว่า "ทิ้งทุกอย่างแล้วกลับไปหน้าล็อกอิน" ของที่กรอกค้างไว้หายหมด
        // ดักที่คอขวดจุดเดียวตรงนี้แทนการไล่แก้ทุก call site: ถ้ายังรู้ว่าเป็นใครอยู่
        // ให้ SessionGuard ขึ้นล็อกอิน **ซ้อนทับ** แล้วคงหน้าจอเดิมไว้ทั้งดุ้น (เจ้าของเคาะ §6)
        // ทางออกจริง ๆ ของผู้ใช้คือปุ่ม "ออกจากระบบ" ใน dialog นั้น → logout() ตามปกติ
        if (this.$refs.sessionGuard && localStorage.getItem('userdata')) {
          this.$refs.sessionGuard.showExpired('expired');
          this.onLoading(false);
          return;
        }
        live.stop();   // อีกทางออกหนึ่งของ session — ต้องปิดสายเหมือน logout()
        this.deferredPage = null;
        this.deferredLanding = null;
        this.$store.dispatch('logout');
        localStorage.removeItem('userdata');
        // ⚠️ ต้องลบ token ออกจาก localStorage ด้วย — `logout` ล้างแค่ state ใน Vuex
        // ถ้าทิ้ง token ไว้โดยไม่มี userdata จะเกิด deadlock: พอโหลดหน้าใหม่ Login.created()
        // เห็น token → ยิง /verifyToken → ผ่าน (JWT ยังไม่หมดอายุ) → auto-login โดยไม่ตั้ง showLogin
        // แต่ AffterLogin() ทำอะไรไม่ได้เพราะไม่มี userdata → เด้งกลับ state='login'
        // ผลคือฟอร์มล็อกอินไม่ถูกวาด = จอขาว และวนซ้ำทุกครั้งที่รีเฟรช
        // (เจ้าของเจอจริงบน prod 2026-07-31 — hard refresh ไม่หาย ต้องล้าง site data)
        localStorage.removeItem('token');
        this.myMenus = null
        this.onLoading(false)
        this.drawer = false
        this.black = false
        this.state = state
        return;
      }
      if (!this.isStateAllowed(state)) {
        this.onError(this.$t('common.noAccess'));
        return;
      }
      // เดินเมนู/เปลี่ยนหน้าเองตามปกติ = ล้างวันที่ค้างมาจากการ์ดแจ้งเตือน ไม่งั้นกดเมนู
      // "ตารางสอนโค้ช" ครั้งต่อไปจะยังเปิดค้างที่วันของนัดหมายเก่า ซึ่งไม่ใช่สิ่งที่ผู้ใช้คาด
      // (มีแค่ openFromNotification ที่ส่ง keepNotifyDate มา)
      if (!opts || !opts.keepNotifyDate) this.notifyDate = null;
      // ผู้ใช้เลือกหน้าเองระหว่างที่หน้าจากลิงก์ยังรอสิทธิ์อยู่ = ยกเลิกคำขอนั้น ไม่งั้นพอ /getMyMenus
      // ตอบกลับมาจะดึงผู้ใช้ย้อนไปหน้าที่ขอไว้ทับสิ่งที่เพิ่งกด · แทนที่ประวัติของคำขอที่ทิ้งไป
      if (this.deferredPage) {
        this.deferredPage = null;
        this.deferredLanding = null;
        this.replaceNextUrl = true;
      }
      this.drawer = false
      this.black = false
      this.state = state
      console.log('State changed to:', this.state, 'Drawer closed:', !this.drawer);
    },
    // ── การ์ดที่เด้งจากระบบปฏิบัติการ (Web Push) ถูกกด ────────────────────────
    // มาได้ 2 ทาง และต้องรองรับทั้งคู่:
    //   1. แอปเปิดอยู่แล้ว → service worker ส่ง postMessage เข้ามา (ไม่รีโหลดหน้า)
    //   2. แอปยังไม่เปิด → SW เปิดแท็บใหม่พร้อม ?nk=&nd= แล้วเราอ่านตอนบูต
    // ทางที่ 2 ต้องล้าง query ทิ้งทันทีหลังอ่าน ไม่งั้นผู้ใช้กดรีเฟรชทีไรก็เด้งไปวันเดิมซ้ำ ๆ
    onSwNotificationClick(event) {
      // หน้าต่างแยกไม่รับการ์ดแจ้งเตือน — sw.js เลือกส่งให้หน้าต่างหลักอยู่แล้ว นี่คือกันชั้นที่สอง
      // (SW ตัวเก่าที่ยังไม่อัปเดตอาจส่งมาที่นี่ได้)
      if (this.embed) return;
      const d = (event && event.data) || {};
      if (d.type !== 'istar-notification-click') return;
      this.openFromNotification({ refkind: d.refkind, refid: d.refid, date: d.date });
    },
    // อ่านปลายทางที่ติดมากับ URL (เคสแอปยังไม่เปิด) แล้วล้าง query ทิ้ง
    // ยังไม่พาไปทันทีตรงนี้ เพราะตอนบูตอาจยังไม่ล็อกอิน — เก็บไว้ให้ AffterLogin ใช้ต่อ
    captureNotificationFromUrl() {
      try {
        const q = new URLSearchParams(window.location.search);
        const nk = q.get('nk');
        if (!nk) return;
        this.pendingNoti = { refkind: nk, date: q.get('nd') || null };
        q.delete('nk'); q.delete('nd');
        const rest = q.toString();
        window.history.replaceState(null, '',
          window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
      } catch (e) { /* URL แปลก ๆ — ไม่ใช่เรื่องคอขาดบาดตาย ปล่อยผ่าน */ }
    },

    // กดการ์ดแจ้งเตือน → เปิดหน้าที่ "ดูเรื่องนั้นได้จริง" พร้อมเปิดที่วันของนัดหมายนั้นเลย
    //
    // เลือกปลายทางจากสิทธิ์ที่มีจริง (allowedStates) ไม่ใช่จากการเดา usertype — โค้ชได้
    // 'coachschedule' (ตารางสอนของตัวเอง มีการ์ด "ตารางสอน Private" ของวันนั้นอยู่แล้ว)
    // ส่วน head/admin ที่ไม่ได้เปิดเมนูนั้นให้ตัวเองก็ยังตกไปที่หน้าจัดการจอง Private ได้
    // ผู้ใช้ที่ไม่มีสิทธิ์ทั้งคู่ = ไม่พาไปไหน ดีกว่าพาไปแล้วเด้ง "ไม่มีสิทธิ์เข้าถึงหน้านี้" ใส่หน้า
    //
    // notifyDate ถูกส่งต่อเป็น prop ให้หน้าปลายทางเปิดที่วันนั้น — จุดสำคัญของฟีเจอร์นี้คือ
    // "กดแล้วเห็นคาบที่ถูกแจ้ง" ไม่ใช่เปิดหน้าเปล่าที่วันนี้แล้วให้ไปกดหาวันเอง
    openFromNotification(payload) {
      const p = payload || {};
      // ปลายทางต่อ "เรื่อง" — เรียงจากหน้าที่ตอบโจทย์การ์ดนั้นที่สุด แล้วเลือกอันแรกที่คนนี้เปิดได้
      //   private_booking  → ตารางสอนของโค้ช / หน้าจัดการจอง Private
      //   customer_course  → หน้าแรกของผู้ปกครอง (การ์ดลูก + ปุ่มจองอยู่ตรงนั้น) · สตาฟที่มีลูก
      //                      เรียนที่นี่ด้วยแต่ไม่มีเมนู 'home' ตกไปที่หน้าจัดการคอร์สแทน
      const ROUTES = {
        // เดิมมีแค่โค้ช/สตาฟ — การ์ด "ย้ายคาบ Private" ถึงผู้ปกครองด้วยแล้ว (be #360) ใช้
        // refkind เดียวกัน จึงต้องมีปลายทางฝั่งผู้ปกครองด้วย ('home' เป็นตัวสุดท้าย ไม่แย่ง
        // ลำดับความสำคัญของโค้ช/สตาฟที่มีสิทธิ์เมนูอยู่แล้ว)
        private_booking: ['coachschedule', 'privatebookingmanager', 'home'],
        customer_course: ['home', 'customercourse'],
        // การ์ดอีเวนต์ (สมัคร/ค้างชำระ/รับเงินแล้ว) — ผู้ปกครองไปหน้าแรกที่มีบล็อกอีเวนต์
        // สตาฟไปหน้าจัดการอีเวนต์ · เรียงตามสิทธิ์ที่คนนั้นมีจริง (candidates.find)
        event_registration: ['home', 'eventmanager'],
        // การ์ดแจ้งผู้จัดการ (เช่น ลบแพ็กเกจคอร์ส) → หน้าประวัติคอร์สที่มีปุ่มกู้คืน
        admin_action: ['customercoursefinished'],
        // การ์ดย้ายคาบเรียนกลุ่มถึงผู้ปกครอง (be #360) → หน้าแรกที่มีการ์ดลูก/ตารางเรียน
        booking_group: ['home'],
        // การ์ดวันหมดอายุคอร์สเปลี่ยน (ผู้ปกครอง) → หน้าแรกที่มีการ์ดลูก/วันหมดอายุ
        course_change: ['home'],
        // คำขอเลื่อนวันหมดอายุ (ถึงผู้จัดการ/ผู้ยื่น) → หน้าคอร์สลูกค้า ที่มีปุ่มรายการคำขอ
        expiry_request: ['customercourse'],
      };
      const candidates = ROUTES[p.refkind];
      if (!candidates) return;
      const target = candidates.find((s) => this.isStateAllowed(s));
      if (!target) return;
      // การ์ดคอร์สไม่มี "วันนัด" ให้เปิดถึง (eventdate = วันหมดอายุ ไม่ใช่วันที่ต้องไปดูอะไร)
      // ส่ง null ไปแทน ไม่งั้นหน้าปลายทางจะกระโดดไปเปิดวันหมดอายุโดยไม่มีเหตุผล
      this.notifyDate = p.refkind === 'private_booking' ? (p.date || null) : null;
      this.onClickChangeState(target, { keepNotifyDate: true });
    },
    onClickBack(state) {
      this.deferredPage = null;
      this.deferredLanding = null;
      this.black = false
      this.state = state
    },
    // เปิดระบบเอกสารรับจ่าย (subdomain แยก) — ส่ง booking JWT ผ่าน #t handoff
    //   payment /auth/sso จะ verify token + re-check usertype=0 ฝั่ง server อีกชั้น (defense-in-depth)
    openPaymentSystem() {
      const token = localStorage.getItem('token')
      if (!token) { this.onError(this.$t('auth.pleaseLoginAgain')); return }
      const base = 'https://istarpayment.istar-gymnastics.com'
      window.open(base + '/#t=' + encodeURIComponent(token), '_blank', 'noopener')
      this.drawer = false
    },
    initBlackButton(state) {
      this.black = true
      this.recentState = state
    },
    backToLogin() {
      this.state = 'login'
    },
    // ล็อกอินซ้ำผ่าน SessionGuard สำเร็จ — โหลดสิทธิ์/เมนูใหม่โดย **ไม่เปลี่ยน state**
    // (นั่นคือหัวใจของ overlay: หน้าจอเดิมกับของที่กรอกค้างไว้ต้องอยู่ครบ)
    // เคส `permission-changed` ถ้าไม่โหลดเมนูใหม่ ผู้ใช้จะเห็นเมนูชุดเก่าแล้วกดโดน 403 วนกลับมาที่ dialog
    afterRelogin() {
      this.fetchMyMenus();
      this.rebindPush();
    },
    invalidToken() {
      this.$router.push('/')
    },
    onError(msg) {
      this.errorMsg = msg
      this.errorDialog = true
      this.$emit('onLoading', false)
    },
    onShowInfoDialog(msg) {
      this.infoMsg = msg
      this.successDialog = true
    },
    onSuccess(msg) {
      this.infoMsg = msg
      this.successDialog = true
      this.state = 'login'
    },
    onClickLogout() {
      this.ConfirmLogoutDialog = true
    },
    async logout() {
      this.ConfirmLogoutDialog = false;
      live.stop();   // ปิดสายก่อนล้างโทเคน ไม่งั้นมันจะพยายามต่อใหม่ด้วยใบที่เพิ่งถูกเพิกถอน
      this.deferredPage = null;      // ออกระหว่างหน้าจากลิงก์ยังรอสิทธิ์ — ยกเลิกคำขอนั้น
      this.deferredLanding = null;
      try {
        // ใช้โทเคนล่าสุดใน localStorage (แชร์ทุกแท็บ) — แท็บนี้อาจถือใบเก่าที่แท็บอื่นเพิ่งแทนที่
        // ถ้าเพิกถอนใบเก่าแต่ลบใบใหม่ของแท็บอื่นทิ้ง จะเหลือ session ที่ยังไม่ถูกเพิกถอน/แท็บอื่นเด้งทั้งที่ยังดีอยู่
        const token = localStorage.getItem('token') || this.$store.getters.getToken;

        // ── ตัดการแจ้งเตือนแบบเด้งขึ้นจอ (Web Push) ก่อนล้าง token ────────────
        // subscription ของ Web Push อยู่ที่ "เบราว์เซอร์/ระบบปฏิบัติการ" ไม่ผูกกับ JWT ของเรา
        // ถ้าไม่ตัดตรงนี้ คนที่กด "ออกจากระบบ" แล้วจะยังได้แจ้งเตือนคาบสอนเด้งขึ้นจอต่อไป
        // เรื่อย ๆ (พร้อมชื่อเล่นเด็กบนหน้าจอล็อก) ทั้งที่ตั้งใจออกไปแล้ว — เป็นทั้งเรื่อง
        // ข้อมูลรั่วบนเครื่องที่แชร์กัน และเรื่องที่ผู้ใช้กดปิดเองไม่ได้เพราะล็อกอินไม่อยู่แล้ว
        //
        // ⚠️ ต้องทำ "ก่อน" ล้าง token เพราะ /deletePushSubscription ต้องใช้ Authorization
        // และห้ามให้ล้มแล้วบล็อกการออกจากระบบ — disablePush กลืน error ของตัวเองอยู่แล้ว
        await disablePush({
          remove: (endpoint) => axios.post(this.baseURL + '/deletePushSubscription', { endpoint },
            { headers: { Authorization: `Bearer ${token}` } }),
        });

        await axios.post(this.baseURL + '/logout', {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then(() => {
            this.$store.dispatch('logout');
            localStorage.removeItem('userdata');
            localStorage.removeItem('token');
            this.state = 'login'
            this.drawer = false
          })
      } catch (error) {
        // Handle errors
        //console.error('Error during logout:', error);
        localStorage.removeItem('userdata');
        localStorage.removeItem('token');
        this.state = 'login'
        this.drawer = false
      }
      this.adminflag = false
      this.managerflag = false
      this.coachflag = false
      this.customerflag = false
      this.bookingAccessRestricted = false
      this.myMenus = null
    },
    onLoading(loading) {
      //this.loadingDialog = loading
      this.isLoading = loading;
    },
    handleListClick(event) {
      console.log('List clicked:', event);
    },
    // Swap the festival palette by toggling a class on <html>. The token
    // overrides in istar-themes.css (html.theme-*) win over the :root base,
    // so 'default' simply means "no festival class" → the iStar pink baseline.
    applyUITheme(theme) {
      const el = document.documentElement;
      // every festival id has a matching html.theme-<id> block in istar-themes.css;
      // 'default' = no class (the :root pink baseline)
      FESTIVAL_THEME_IDS.forEach((id) => el.classList.remove('theme-' + id));
      el.classList.remove('theme-dark');
      if (this.prefersDark) {
        // เครื่องเปิดโหมดมืด → ชุดมืดกลาง "แทนที่" ธีมฤดูกาล ไม่ใช่ทับซ้อน (ดู effectiveTheme
        // และหัวบล็อก html.theme-dark ใน istar-themes.css ว่าทำไมถึงไม่ผสมกัน)
        el.classList.add('theme-dark');
      } else if (theme && FESTIVAL_THEME_IDS.includes(theme)) {
        el.classList.add('theme-' + theme);
      }
      this.syncStatusBarColor();
    },
    // ผู้ใช้สลับโหมดสว่าง/มืดที่ตัวเครื่องขณะเปิดแอปค้างอยู่ → ทาสีใหม่ทันที ไม่ต้องรีเฟรช
    // (บนมือถือที่ตั้ง "มืดอัตโนมัติตามเวลา" เหตุการณ์นี้เกิดเองกลางดึกโดยผู้ใช้ไม่ได้แตะอะไร)
    onSystemDarkChange(e) {
      this.prefersDark = e.matches;
      this.applyUITheme(this.uiTheme);
    },
    // ตาข่ายกันพลาดของ listener ข้างบน: เหตุการณ์ 'change' ไม่ยิงเสมอไป โดยเฉพาะตอนแอปอยู่
    // เบื้องหลัง ซึ่งเป็นเคสที่เกิดจริงบ่อยที่สุด — มือถือที่ตั้ง "มืดอัตโนมัติตามเวลา" จะสลับ
    // ตอนดึกโดยผู้ใช้ไม่ได้เปิดแอปค้างไว้ พอกลับมาเปิดจึงต้องเทียบค่าปัจจุบันอีกรอบ
    // ไม่งั้นจะเห็นธีมสว่างทั้งที่เครื่องมืดอยู่ จนกว่าจะปิดเปิดแอปใหม่
    onVisibilityChange() {
      // มือถือที่หลับไปแล้วตื่นมา: สายอาจตายไปแล้วแต่ `readyState` ยังค้างเป็น OPEN ได้นาน
      // จึงต้องทิ้งแล้วต่อใหม่เสมอ ไม่ใช่เช็คก่อน (ดูหลักการข้อ 2 ใน utils/live.js)
      if (document.visibilityState === 'visible' && this.$store.getters.isLoggedIn) live.resume();
      if (document.visibilityState !== 'visible' || !this.systemDarkQuery) return;
      if (this.systemDarkQuery.matches !== this.prefersDark) {
        this.onSystemDarkChange({ matches: this.systemDarkQuery.matches });
      }
    },
    // The OS window chrome — the Android status bar in an installed PWA — is painted from
    // <meta name="theme-color">, which lives OUTSIDE the CSS token system and therefore does
    // NOT follow html.theme-*. It was hardcoded to the pink brand colour (--c-primary,
    // #ec4899), so a pink strip sat above the app on every theme, seasonal ones included.
    //
    // Read --c-bg instead: it is a solid hex in :root and in all 9 theme blocks, so the strip
    // always matches the top of the page. Reading the token (rather than mapping colours here)
    // means a new seasonal theme — or a future dark mode — is picked up with no change to this
    // file. The meta tag also takes precedence over manifest.json's theme_color, so a device
    // that already installed the PWA updates immediately instead of waiting for Chrome to
    // refresh the WebAPK.
    syncStatusBarColor() {
      const bg = getComputedStyle(document.documentElement).getPropertyValue('--c-bg').trim();
      if (!bg) return;
      let meta = document.querySelector('meta[name="theme-color"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'theme-color');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', bg);
    },
    selectTheme(theme) {
      // System-wide theme: only head/admin may change it (backend must enforce too).
      if (!this.canEditTheme) return;
      this.uiTheme = theme;
      this.applyUITheme(theme);
      try { localStorage.setItem('uiTheme', theme); } catch (e) { /* storage unavailable */ }
      this.themeMenu = false;
      this.saveGlobalTheme(theme);
    },
    // Persist the global theme for everyone. This used to swallow every error, which hid the
    // fact that 6 of the 9 themes were rejected by the backend whitelist: the head picked a
    // theme, saw it apply on their own screen, and never found out nobody else got it.
    // Now a failure is surfaced and the caller is told the change is local-only.
    async saveGlobalTheme(theme) {
      try {
        const token = this.$store.getters.getToken;
        const res = await axios.post(this.baseURL + '/saveAppSettings', { uiTheme: theme }, {
          headers: { Authorization: 'Bearer ' + token },
        });
        if (res && res.data && res.data.success === false) {
          this.errorMsg = res.data.message || this.$t('theme.saveFailed');
          this.errorDialog = true;
        }
      } catch (e) {
        // 403 = ไม่ใช่ผู้จัดการ (ปุ่มถูกซ่อนอยู่แล้ว), 400 = ธีมไม่อยู่ใน whitelist ของ backend
        this.errorMsg = (e.response && e.response.data && e.response.data.message) || this.$t('theme.saveFailed');
        this.errorDialog = true;
      }
    },
    // Read the global theme set by the head and apply it to this user. No-op on
    // failure (keeps the cached/default theme), so the app never breaks if the
    // endpoint is missing.
    async fetchGlobalTheme() {
      try {
        const token = this.$store.getters.getToken;
        const res = await axios.post(this.baseURL + '/getAppSettings', {}, {
          headers: token ? { Authorization: 'Bearer ' + token } : {},
        });
        const data = res && res.data ? (res.data.settings || res.data) : null;
        const theme = data && data.uiTheme;
        if (theme && THEME_IDS.includes(theme)) {
          this.uiTheme = theme;
          this.applyUITheme(theme);
          try { localStorage.setItem('uiTheme', theme); } catch (e) { /* ignore */ }
        }
      } catch (e) {
        // no global setting available — keep the cached / default theme
      }
    },
  },
  mounted() {
    // Keep the playful base class for any not-yet-migrated Vuetify pages; the new
    // design system (istar-design.css) is always active on top of it.
    document.documentElement.classList.add('theme-playful');
    document.body.classList.add('theme-playful');
    // Apply the cached seasonal theme instantly (no flash), then sync the
    // head-controlled global theme from the backend.
    this.applyUITheme(this.uiTheme);
    this.fetchGlobalTheme();
    // ฟังการสลับโหมดสว่าง/มืดที่ตัวเครื่อง · เก็บ MediaQueryList ไว้เป็น property ธรรมดา
    // (ไม่ใส่ใน data) เพราะไม่ต้องการให้ Vue ห่อเป็น reactive proxy — ต้องส่ง "ตัวเดิม"
    // กลับเข้า removeEventListener ตอน beforeUnmount ไม่งั้นถอด listener ไม่ออก
    if (window.matchMedia) {
      this.systemDarkQuery = window.matchMedia('(prefers-color-scheme: dark)');
      this.systemDarkQuery.addEventListener('change', this.onSystemDarkChange);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    // แอปเปิดอยู่แล้วตอนผู้ใช้กดการ์ดที่เด้งจากระบบปฏิบัติการ → service worker จะส่งเข้ามาทางนี้
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', this.onSwNotificationClick);
    }
    // สั่งเช็คว่ามี sw.js ตัวใหม่ไหมทุกครั้งที่เปิดแอป — ไม่งั้นเครื่องที่เคยสมัครแจ้งเตือนไว้
    // จะค้างอยู่กับ service worker ตัวเก่าไปอีกเป็นวัน แม้ deploy แก้บั๊กไปแล้ว
    // (ไม่มี registration อยู่ = ไม่ทำอะไร ไม่ไปสมัครให้เองโดยผู้ใช้ไม่ได้สั่ง)
    refreshServiceWorker();
    window.addEventListener('resize', this.onViewportResize);
    window.addEventListener('popstate', this.onPopState);
    if (this.embed) window.addEventListener('storage', this.onEmbedStorage);
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.onPopState);
    window.removeEventListener('storage', this.onEmbedStorage);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.removeEventListener('message', this.onSwNotificationClick);
    }
    window.removeEventListener('resize', this.onViewportResize);
    if (this.systemDarkQuery) {
      this.systemDarkQuery.removeEventListener('change', this.onSystemDarkChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  },
  created() {
    // ต้องอ่าน "ก่อน" อย่างอื่น: แท็บที่ service worker เพิ่งเปิดขึ้นมาจากการกด push
    // พก ?nk=&nd= มาด้วย — เก็บไว้แล้วล้าง query ทันที เดี๋ยว AffterLogin ค่อยพาไป
    this.captureNotificationFromUrl();
    this.capturePageFromUrl();
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
    }),
    isAuthScreen() {
      return ['login', 'register', 'forgotpassword'].includes(this.state);
    },
    // FAB ของ AI Chatbot: แสดงเมื่อล็อกอินแล้ว + มีสิทธิ์เมนู chatbot (ผูก myMenus ไม่ผูก role — MENU_SCROPE §2)
    // ระหว่างรอ /getMyMenus (myMenus === null) ใช้ fallback = ผู้จัดการ เหมือน sidebar
    showChatbotFab() {
      if (this.isAuthScreen || !this.isLoggedIn || this.embed) return false;
      if (this.state === 'chatbot') return false; // อยู่หน้าผู้ช่วย AI เต็มจอแล้ว ปุ่มลอยซ้ำซ้อน
      return this.myMenus === null ? this.managerflag : this.myMenus.includes('chatbot');
    },
    userRoleLabel() {
      if (this.managerflag) return this.$t('role.head');
      if (this.adminflag) return this.$t('role.admin');
      if (this.coachflag) return this.$t('role.coach');
      if (this.customerflag) return this.$t('role.customer');
      return '';
    },
    navGroups() {
      // ขับด้วยสิทธิ์จาก /getMyMenus (myMenus) เมื่อได้คำตอบแล้ว; ระหว่างรอ/ล้มเหลว ใช้ fallback
      // ใน MENU_GROUPS ซึ่งคือ matrix เดิมที่เคย hardcode ไว้ตรงนี้ — backend บังคับสิทธิ์จริง
      // ทุก endpoint อยู่แล้ว เมนูฝั่งนี้เป็นแค่การแสดงผล
      const flags = {
        manager: this.managerflag,
        admin: this.adminflag,
        coach: this.coachflag,
        customer: this.customerflag,
        loggedIn: this.isLoggedIn,
      };
      const allowedSet = this.myMenus === null ? null : new Set(this.myMenus);
      const groups = [];
      for (const grp of MENU_GROUPS) {
        const items = [];
        for (const it of grp.items) {
          // เมนู head-only (หน้าจัดการสิทธิ์เอง) ตัดสินจาก role ในโค้ดเท่านั้น ไม่ผ่าน DB — กัน lockout:
          // ต่อให้ข้อมูลสิทธิ์ใน DB เสีย ผู้จัดการก็ยังเข้าหน้านี้มาแก้ได้เสมอ
          const visible = it.headOnly
            ? this.managerflag
            : (allowedSet ? allowedSet.has(it.key) : it.fallback(flags));
          if (visible) {
            items.push({ value: it.value, icon: it.icon, label: this.$t(it.labelKey), external: it.external });
          }
        }
        if (items.length) groups.push({ key: grp.labelKey, label: this.$t(grp.labelKey), items });
      }
      return groups;
    },
    // เมนูทั้งหมดที่คนนี้เปิดได้จริง (แบนจากกลุ่ม) — ตัวเลขนี้คือสิ่งที่ตัดสินว่าใช้แท็บล่างหรือไซด์เมนู
    // ไม่นับเมนูภายนอก (เอกสารรับจ่าย) เพราะมันเปิดระบบอื่น ไม่ใช่หน้าจอในแอป
    // หน้าที่เปิดอยู่ในรูป "ที่อยู่ได้" (substate → หน้าแม่) — ใช้กับปุ่มแยกหน้าต่างบนแถบบน
    currentPage() {
      return pageOfState(this.state);
    },
    // ปุ่มแยกหน้าต่างมีเฉพาะจอกว้างที่มีเมาส์ — มือถือ/แท็บเล็ต (จอแตะ) เปิด popup จริงไม่ได้
    // ได้แค่แท็บเปล่าไม่มีแถบเบราว์เซอร์ ซึ่งแย่กว่าไม่มีปุ่ม
    canPopOut() {
      return !this.isNarrow && this.hasHoverPointer;
    },
    flatMenuItems() {
      return this.navGroups.flatMap((g) => g.items).filter((i) => !i.external);
    },
    isNarrow() {
      return this.viewportW <= NARROW_BP;
    },
    // รูปแบบที่ 1 = จอมือถือ + เมนู ≤4 · เกินกว่านั้นหรือจอกว้าง = รูปแบบที่ 2 (ไซด์เมนู)
    // ผูกกับ "จำนวนเมนูตามสิทธิ์จริงรายคน" ไม่ใช่ role: โค้ชที่ถูกเพิ่มสิทธิ์จนเกิน 4 จะสลับ
    // ไปไซด์เมนูเองอัตโนมัติโดยไม่ต้องแก้โค้ด
    useBottomTabs() {
      return this.isNarrow && this.flatMenuItems.length > 0
        && this.flatMenuItems.length <= BOTTOM_TAB_MAX;
    },
    bottomTabs() {
      // สร้างจากเมนูจริงของคนนั้น (ไม่ hardcode 3 หน้าของลูกค้าอีกแล้ว) — โค้ชจึงได้แท็บล่าง
      // เป็นเมนูของตัวเอง ไม่ใช่เมนูลูกค้า
      return this.flatMenuItems.slice(0, BOTTOM_TAB_MAX);
    },
    iconUrl() {
      return this.userProfileImage || require('./assets/avatar/1.png');
    },
    themeOptions() {
      return [
        { id: 'default',     name: this.$t('theme.default'),     sub: this.$t('theme.defaultSub'),     swatch: 'linear-gradient(135deg,#ec4899,#a855f7)' },
        { id: 'mothersday',  name: this.$t('theme.mothersday'),  sub: this.$t('theme.mothersdaySub'),  swatch: 'linear-gradient(135deg,#2f8fd6,#5470cf)' },
        { id: 'loykrathong', name: this.$t('theme.loykrathong'), sub: this.$t('theme.loykrathongSub'), swatch: 'linear-gradient(135deg,#e08a2e,#6d3a63)' },
        { id: 'newyear',     name: this.$t('theme.newyear'),     sub: this.$t('theme.newyearSub'),     swatch: 'linear-gradient(135deg,#1e2a52,#d9b14a)' },
        { id: 'songkran',    name: this.$t('theme.songkran'),    sub: this.$t('theme.songkranSub'),    swatch: 'linear-gradient(135deg,#14a9b8,#2f9fe0)' },
        { id: 'halloween',   name: this.$t('theme.halloween'),   sub: this.$t('theme.halloweenSub'),   swatch: 'linear-gradient(135deg,#e8731c,#7c3aed)' },
        { id: 'christmas',   name: this.$t('theme.christmas'),   sub: this.$t('theme.christmasSub'),   swatch: 'linear-gradient(135deg,#c0392b,#1f7a4d)' },
        { id: 'fathersday',  name: this.$t('theme.fathersday'),  sub: this.$t('theme.fathersdaySub'),  swatch: 'linear-gradient(135deg,#cd9b1d,#f0c233)' },
        { id: 'muaythai',    name: this.$t('theme.muaythai'),    sub: this.$t('theme.muaythaiSub'),    swatch: 'linear-gradient(135deg,#b81d2c,#d4a01e)' },
      ];
    },
    activeThemeName() {
      const found = this.themeOptions.find((t) => t.id === this.uiTheme);
      return found ? found.name : this.themeOptions[0].name;
    },
    // ธีมที่ "แสดงจริงบนจอนี้" ซึ่งไม่จำเป็นต้องเท่ากับ uiTheme ที่หัวหน้าตั้งไว้ให้ทั้งระบบ:
    // ถ้าเครื่องเปิดโหมดมืด ธีมฤดูกาลจะถูกแทนที่ด้วยชุดมืดกลางทั้งดุ้น (พาเลตต์ + overlay)
    // เพราะทุกธีมออกแบบมาบนพื้นสว่าง เอามาผสมพื้นมืดแล้วคอนทราสต์พังเป็นหย่อม ๆ
    //
    // ตั้งใจ **ไม่** ให้ตัวเลือกในเมนูจานสีอ่านค่านี้ — หัวหน้าต้องเห็นว่าตัวเองตั้งธีมอะไรไว้
    // ให้คนอื่น แม้เครื่องตัวเองจะมืดอยู่ก็ตาม (จึงยังใช้ uiTheme ที่นั่น)
    effectiveTheme() {
      return this.prefersDark ? 'dark' : this.uiTheme;
    },
    // Theme is a system-wide setting — only the HEAD (usertype 0) may change it (not admins).
    canEditTheme() {
      return this.managerflag;
    },
    // Client-side route guard (defense-in-depth — every backend endpoint already checks role
    // itself; this just stops a lower-privileged state="x" navigation attempt, e.g. via devtools,
    // from even rendering the page). Derived straight from navGroups so it can NEVER drift out
    // of sync with what the sidebar already shows — one source of truth, not a second hardcoded list.
    allowedStates() {
      const fromMenu = this.navGroups.flatMap((g) => g.items.map((i) => i.value));
      const set = new Set(fromMenu);
      // sub-flows reachable from a visible page but not themselves top-level menu items —
      // declared per-menu in MENU_GROUPS (substates) so they always follow the parent
      // menu's permission (e.g. reservation/groupreservation follow 'home')
      for (const v of fromMenu) {
        const def = MENU_ITEM_BY_VALUE[v];
        if (def && def.substates) def.substates.forEach((s) => set.add(s));
      }
      // 'editprofile' ไม่ใช่เมนูในทะเบียน (สตาฟเข้าจากแถวโปรไฟล์บนสุดของไซด์บาร์ ลูกค้าเข้าจาก
      // เมนูรูปโปรไฟล์มุมซ้ายบน) แต่ทุกคนที่ล็อกอินเข้าได้เสมอ —
      // เป็นข้อมูลของตัวเอง ไม่ผูกกับสิทธิ์เมนู (backend ก็ตั้ง core:'always' ให้ menukey นี้)
      if (this.isLoggedIn) set.add('editprofile');
      return set;
    },
  }
}
</script>
<style src="./styles/global-style.css"></style>
<style scoped>
/* ===== FIXED-HEIGHT APP SHELL =====
   Shell fills the viewport and does NOT scroll. The sidebar and topbar are
   fixed flex children that stay put; ONLY .page scrolls. Result: one scrollbar
   (the content area), pinned menu + topbar regardless of page length, and
   horizontal overflow contained — no position:sticky, no body overflow hacks. */
.shell {
  width: 100%;
  max-width: 100vw;
  /* fixed to the visible viewport, not 100vh: on mobile Chrome 100vh/100dvh can be taller than the
     visible area (870 vs 813px on Z Fold 7), which makes the document scroll ~57px and exposes the
     body background as a white strip at the bottom. Fixed inset:0 can never be taller than the screen. */
  position: fixed;
  inset: 0;
  min-height: 0; /* istar-pages.css sets .shell { min-height:100vh } — that alone made it 870px on the 813px screen */
  /* No overflow rule needed: children are height:100vh so nothing overflows the
     shell — .page scrolls itself, .side scrolls itself (both modes), and the
     collapsed-rail hover hint is a position:fixed .nav-tip that no ancestor clips. */
}

.side {
  height: 100%;
  z-index: 100; /* keep the sidebar (and its shadow) above page cards */
  /* compact spacing so the manager's long menu fits without needing a scrollbar */
  padding: 10px 10px;
}
/* the scrollbar skin follows the element that actually scrolls — that is .side-nav now,
   not .side (the profile header and the ย่อเมนู/ออกจากระบบ footer sit outside it) */
.side-nav {
  /* .side's 10px padding applies on every side, so .side-nav's own right edge (where the
     scrollbar renders) sat 10px inboard of the sidebar's true edge — right where long menu
     labels end, so the thumb visually overlapped them. Claim that 10px back with a negative
     margin (moves the scrollbar flush to the sidebar's true right edge) and restore it as
     padding on the content side (nav-item text lands at the exact same x as before — only
     the scrollbar itself moves, opening MORE clearance from the text, not less). */
  margin-right: -10px;
  padding-right: 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.35) transparent;
}
.side-nav::-webkit-scrollbar { width: 5px; }
.side-nav::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.35); border-radius: 3px; }
.side-nav::-webkit-scrollbar-track { background: transparent; }
.side-brand { padding: 6px 8px 8px; }
.nav-sec { margin: 7px 10px 2px; }
.nav-item { padding: 7px 11px; margin-bottom: 1px; }
.side-divider { margin: 5px 6px; }

.main {
  min-width: 0;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--c-bg-grad);
  /* establish a stacking context so the seasonal overlay (position:absolute;
     z-index:-1) paints ABOVE this gradient but BELOW the topbar + page content.
     Safe: every menu/dialog in the app is a Vuetify overlay teleported out of
     here, so nothing in-page relies on escaping this context. */
  position: relative;
  z-index: 0;
}

/* taller, roomier top bar — fixed at the top of the main column */
.topbar {
  height: 78px;
  flex-shrink: 0;
}

.topbar strong {
  font-size: 19px;
}

/* larger profile avatar on the top bar (the shared .tt-avatar stays 30px elsewhere) */
.topbar .tt-avatar {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  font-size: 16px;
}

/* Narrow phones — the outer screen of a folding phone is ~344px wide, where the
   page title wrapped to three or four lines and pushed itself out of the fixed-height
   bar. Every page already repeats its own title as the .pg-head heading immediately
   below, so the copy in the bar is redundant: drop it and the row becomes one stable
   strip of controls that looks the same on every screen instead of shifting with the
   length of each page's name. The avatar deliberately keeps its 42px size. */
@media (max-width: 560px) {
  .topbar {
    height: 64px;
    padding: 0 12px;
    gap: 8px;
  }

  .topbar strong {
    display: none;
  }
}

/* the ONE scroll area: fills remaining height, scrolls vertically, clips wide content */
.page {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  /* always reserve the scrollbar gutter so content width doesn't change when the
     scrollbar appears/disappears — prevents aspect-ratio calendars from oscillating */
  scrollbar-gutter: stable;
}

/* ROOT FIX: not-yet-migrated pages wrap content in .container-content which is
   width:98vw — too wide now that the sidebar takes 264px. Make those fill the
   page instead of the viewport so they no longer spill under the sidebar. */
.page :deep(.container),
.page :deep(.container-header),
.page :deep(.container-content) {
  width: 100%;
  max-width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
